import React, { useState, useMemo, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import {
  obtenerCatalogoMaguey,
  obtenerTrazabilidadAsociado,
  obtenerInstalacionesProduccion,
  obtenerGranelesPorLogin
} from "../../../redux/DucksBeneficiario/BitacoraProduccionDucks";
import {
  obtenerGranelesEnvasadoPorLogin,
  obtenerTodosGranelesEnvasadoPorLogin,
  registrarGranelEnvasado,
  importarGranelDesdeProduccion,
  registrarFusionGranelEnvasado,
  deshacerMovimientoGranelEnvasado,
  actualizarGranelEnvasado,
  registrarTrasladoGranelEnvasado,
  registrarDilucionGranelEnvasado,
  registrarBajaGranelEnvasado,
  registrarMuestreoGranelEnvasado,
  obtenerReprocesosEnvasadoPorLogin,
  registrarReprocesoEnvasado,
  actualizarReprocesoEnvasado,
  eliminarReprocesoEnvasado,
  obtenerEnvasadosNoTerminadosPorLogin,
  obtenerEnvasadosTerminadosPorLogin,
  registrarEnvasadoProducto,
  actualizarEnvasadoProducto,
  asignarHologramasEnvasado,
  dictaminarEnvasadoProducto,
  obtenerHologramasPorLogin,
  registrarInventarioHologramas,
  registrarMovimientoHolograma,
  obtenerMaduracionEnvasadoPorLogin,
  registrarMaduracionEnvasadoAsociado,
  actualizarMaduracionEnvasadoAsociado,
  eliminarMaduracionEnvasadoAsociado,
  obtenerCondicionesEnvasadoPorLogin,
  registrarCondicionesEnvasadoAsociado,
  actualizarCondicionesEnvasadoAsociado,
  eliminarCondicionesEnvasadoAsociado
} from "../../../redux/DucksBeneficiario/BitacoraEnvasadoDucks";
import "./BitacoraProduccion.css";
import "./BitacoraEnvasado.css";

// Material UI Icons
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LocalBarIcon from '@mui/icons-material/LocalBar';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import ScienceIcon from '@mui/icons-material/Science';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

// Subcomponents
import InventarioGranelSection from "./BitacoraEnvasado/InventarioGranelSection";
import EnvasadoNoTerminadoSection from "./BitacoraEnvasado/EnvasadoNoTerminadoSection";
import EnvasadoTerminadoSection from "./BitacoraEnvasado/EnvasadoTerminadoSection";
import ControlHologramasSection from "./BitacoraEnvasado/ControlHologramasSection";
import ReprocesoSection from "./BitacoraEnvasado/ReprocesoSection";
import InventarioMaduracionSection from "./BitacoraEnvasado/InventarioMaduracionSection";
import CondicionesSection from "./BitacoraEnvasado/CondicionesSection";
import QuejasSection from "./BitacoraEnvasado/QuejasSection";
import { rangosParaEnviar } from "./BitacoraEnvasado/salidasRangos";
import { subirDocumentosPendientesDeRangos, subirDocumentosPendientesDeSalidas } from "./BitacoraEnvasado/ModalDocumentosRangoHolograma";

const BitacoraEnvasado = () => {
  const dispatch = useDispatch();

  // Obtener usuario autenticado e id_login (id: 3462)
  const usuarioData = useSelector(state => state.Usuario?.data || state.Usuario || null);
  const idLogin = usuarioData?.user?.[0]?.id ||
    usuarioData?.user?.id ||
    usuarioData?.idlogin ||
    usuarioData?.id_login ||
    usuarioData?.id ||
    null;

  const reduxTrazabilidadLots = useSelector(state => state.bitacoraProduccion?.trazabilidadLots || []);
  const reduxCatalogoMaguey = useSelector(state => state.bitacoraProduccion?.catalogoMaguey || []);
  const reduxMaduracionRecords = useSelector(state => state.bitacoraEnvasado?.maduracionRecords || []);
  const reduxCondicionesRecords = useSelector(state => state.bitacoraEnvasado?.condicionesRecords || []);
  const [isCondicionesFormOpen, setIsCondicionesFormOpen] = useState(false);
  const [condicionesFormData, setCondicionesFormData] = useState({});
  const reduxGranelRecordsEnvasado = useSelector(state => state.bitacoraEnvasado?.granelRecords || []);
  const reduxAllGranelRecords = useSelector(state => state.bitacoraEnvasado?.allGranelRecords || []);
  const reduxNoTerminados = useSelector(state => state.bitacoraEnvasado?.noTerminadoRecords || []);
  const reduxNoTerminadosLoaded = useSelector(state => state.bitacoraEnvasado?.noTerminadoLoaded || false);
  const reduxTerminados = useSelector(state => state.bitacoraEnvasado?.terminadoRecords || []);
  const reduxTerminadosLoaded = useSelector(state => state.bitacoraEnvasado?.terminadoLoaded || false);
  const reduxHologramas = useSelector(state => state.bitacoraEnvasado?.hologramaRecords || []);
  const reduxHologramasLoaded = useSelector(state => state.bitacoraEnvasado?.hologramasLoaded || false);
  const reduxReprocesos = useSelector(state => state.bitacoraEnvasado?.reprocesoRecords || state.bitacoraEnvasado?.reprocesos || []);
  const reduxLoadingReprocesos = useSelector(state => state.bitacoraEnvasado?.loadingReproceso || state.bitacoraEnvasado?.loadingReprocesos || false);
  const reduxGranelPagination = useSelector(state => state.bitacoraEnvasado?.granelPagination || { total: 0, page: 1, limit: 10, totalPages: 1 });
  const [granelPage, setGranelPage] = useState(1);
  const [granelLimit, setGranelLimit] = useState(10);

  const recargarGranel = (p = granelPage, l = granelLimit) => {
    if (idLogin) {
      dispatch(obtenerGranelesEnvasadoPorLogin({ id_login: idLogin, page: p, limit: l }));
      dispatch(obtenerTodosGranelesEnvasadoPorLogin(idLogin));
    }
  };
  const reduxBitacoraInst = useSelector(state => state.bitacoraProduccion?.instalaciones || []);
  const reduxFC36Inst = useSelector(state => state.FC_36Beneficiario?.instalacionesCliente || []);
  const reduxFC35Inst = useSelector(state => state.FC_35Beneficiario?.instalacionesCliente || []);
  const reduxSolicitudesInst = useSelector(state => state.Solicitudes?.instalacionesCliente || []);
  const reduxInstalacionInst = useSelector(state => state.Instalacion?.instalacionesCliente || []);

  const allAvailableInstalaciones = useMemo(() => {
    const list = [
      ...(Array.isArray(reduxBitacoraInst) ? reduxBitacoraInst : []),
      ...(Array.isArray(reduxFC36Inst) ? reduxFC36Inst : []),
      ...(Array.isArray(reduxFC35Inst) ? reduxFC35Inst : []),
      ...(Array.isArray(reduxSolicitudesInst) ? reduxSolicitudesInst : []),
      ...(Array.isArray(reduxInstalacionInst) ? reduxInstalacionInst : [])
    ];

    const map = new Map();
    list.forEach(item => {
      if (!item) return;
      const idAnexo = item.idanexocliente || item.id_anexo_cliente || item.id || item.id_unidad_produccion;
      if (!idAnexo || map.has(String(idAnexo))) return;

      const infoGen = item.informaciongeneralinstalacioncliente || item;
      const alias = infoGen?.alias || item.alias || `Instalación #${idAnexo}`;
      const tipo = item.tipo || infoGen?.tipo || (item.idtipoanexo === 1 ? 'Unidad de producción' : item.idtipoanexo === 2 ? 'Unidad de envasado' : item.idtipoanexo === 3 ? 'Unidad de almacén' : 'Instalación');

      let dir = infoGen?.direccion || item.direccion;
      if (!dir && infoGen) {
        dir = [
          infoGen.calle,
          infoGen.numeroexterior || infoGen.numext,
          infoGen.colonia,
          infoGen.municipio,
          infoGen.estado
        ].filter(Boolean).join(", ");
      }
      dir = dir || "Domicilio registrado";

      map.set(String(idAnexo), {
        ...item,
        idanexocliente: idAnexo,
        id: idAnexo,
        alias: alias,
        direccion: dir,
        tipo: tipo,
        idtipoanexo: item.idtipoanexo || (tipo.toLowerCase().includes("envasado") ? 2 : tipo.toLowerCase().includes("almac") ? 3 : 1),
        informaciongeneralinstalacioncliente: {
          ...infoGen,
          alias: alias,
          direccion: dir,
          tipo: tipo
        }
      });
    });

    return Array.from(map.values());
  }, [reduxBitacoraInst, reduxFC36Inst, reduxFC35Inst, reduxSolicitudesInst, reduxInstalacionInst]);

  // Filtrar exclusivamente las instalaciones de Envasado del asociado
  const envasadoInstalaciones = useMemo(() => {
    const list = allAvailableInstalaciones.filter(inst => {
      const idTipo = Number(inst.idtipoanexo);
      const tipo = String(inst.tipo || inst.informaciongeneralinstalacioncliente?.tipo || '').toLowerCase();
      const alias = String(inst.alias || inst.informaciongeneralinstalacioncliente?.alias || '').toLowerCase();
      return idTipo === 2 || tipo.includes('envasad') || alias.includes('envasad');
    });
    return list.length > 0 ? list : allAvailableInstalaciones;
  }, [allAvailableInstalaciones]);

  // Filtrar exclusivamente las instalaciones de Almacén del asociado
  const almacenInstalaciones = useMemo(() => {
    const list = allAvailableInstalaciones.filter(inst => {
      const idTipo = Number(inst.idtipoanexo);
      const tipo = String(inst.tipo || inst.informaciongeneralinstalacioncliente?.tipo || '').toLowerCase();
      const alias = String(inst.alias || inst.informaciongeneralinstalacioncliente?.alias || '').toLowerCase();
      return idTipo === 3 || tipo.includes('almac') || alias.includes('almac');
    });
    return list.length > 0 ? list : allAvailableInstalaciones;
  }, [allAvailableInstalaciones]);

  const availableInstalaciones = envasadoInstalaciones;
  const reduxGranelesProduccion = useSelector(state => state.bitacoraProduccion?.granelRecords || []);

  // Batch selector
  const [activeBatch, setActiveBatch] = useState("Lote 01-ENV-2026");
  const [showBatchDropdown, setShowBatchDropdown] = useState(false);
  const batches = ["Lote 01-ENV-2026", "Lote 02-ENV-2026", "Lote 03-ENV-2026"];

  // Tab navigation state
  const [activeTab, setActiveTab] = useState(0);
  const [isFormOpen, setIsFormOpen] = useState(false);

  useEffect(() => {
    dispatch(obtenerCatalogoMaguey());
    if (idLogin) {
      recargarGranel();
      dispatch(obtenerInstalacionesProduccion(idLogin));
      dispatch(obtenerGranelesPorLogin(idLogin));
      dispatch(obtenerTrazabilidadAsociado({ id_login: idLogin }));
      dispatch(obtenerMaduracionEnvasadoPorLogin(idLogin));
      dispatch(obtenerEnvasadosNoTerminadosPorLogin(idLogin));
      dispatch(obtenerEnvasadosTerminadosPorLogin(idLogin));
      dispatch(obtenerHologramasPorLogin(idLogin));
      dispatch(obtenerCondicionesEnvasadoPorLogin(idLogin));
    }
  }, [dispatch, idLogin]);

  useEffect(() => {
    if (activeTab === 4 && idLogin) {
      dispatch(obtenerReprocesosEnvasadoPorLogin(idLogin));
    }
    if (activeTab === 1 && idLogin) {
      dispatch(obtenerEnvasadosNoTerminadosPorLogin(idLogin));
      dispatch(obtenerHologramasPorLogin(idLogin));
      dispatch(obtenerEnvasadosTerminadosPorLogin(idLogin));
    }
    if (activeTab === 2 && idLogin) {
      dispatch(obtenerEnvasadosTerminadosPorLogin(idLogin));
      dispatch(obtenerHologramasPorLogin(idLogin));
    }
    if (activeTab === 3 && idLogin) {
      dispatch(obtenerHologramasPorLogin(idLogin));
      dispatch(obtenerEnvasadosTerminadosPorLogin(idLogin));
    }
    if (activeTab === 5 && idLogin) {
      dispatch(obtenerMaduracionEnvasadoPorLogin(idLogin));
    }
    if (activeTab === 6 && idLogin) {
      dispatch(obtenerCondicionesEnvasadoPorLogin(idLogin));
    }
  }, [activeTab, idLogin, dispatch]);

  const tabsInfo = [
    { id: 0, title: "Sección II", name: "Granel", desc: "Inventarios de Mezcal a Granel", icon: LocalBarIcon, shortLabel: "II. Granel", theme: "status-cierre" },
    { id: 1, title: "Sección III", name: "Envasado No Terminado", desc: "Inventario de botellas sin etiquetar", icon: ShoppingBagIcon, shortLabel: "III. No Terminado", theme: "status-coccion" },
    { id: 2, title: "Sección IV", name: "Envasado Terminado", desc: "Inventario de botellas con holograma", icon: WorkspacePremiumIcon, shortLabel: "IV. Terminado", theme: "status-elaboracion" },
    { id: 3, title: "Sección V", name: "Hologramas", desc: "Control del Inventario de Hologramas", icon: ConfirmationNumberIcon, shortLabel: "V. Hologramas", theme: "status-maduracion" },
    { id: 4, title: "Sección VI", name: "Reproceso", desc: "Abocado, destilado con o reprocesos", icon: ScienceIcon, shortLabel: "VI. Reproceso", theme: "status-elaboracion" },
    { id: 5, title: "Sección VII", name: "Maduración", desc: "Inventarios en Maduración", icon: HourglassBottomIcon, shortLabel: "VII. Maduración", theme: "status-maduracion" },
    { id: 6, title: "Sección VIII", name: "Condiciones", desc: "Registro de Condiciones", icon: DeviceThermostatIcon, shortLabel: "VIII. Condiciones", theme: "status-cierre" },
    // { id: 7, title: "Sección IX", name: "Quejas", desc: "Quejas del Producto Certificado", icon: ReportProblemIcon, shortLabel: "IX. Quejas", theme: "status-coccion" }
  ];

  // State para formulario y modal de Reproceso (Sección VI)
  const [isReprocesoFormOpen, setIsReprocesoFormOpen] = useState(false);
  const [reprocesoFormData, setReprocesoFormData] = useState({});

  // ================= DATA HISTORY STATES =================
  const [granelRecords, setGranelRecords] = useState([]);

  const [customGranelRecords, setCustomGranelRecords] = useState([]);
  const [isRefreshingGranel, setIsRefreshingGranel] = useState(false);

  const handleRefreshGranel = async () => {
    if (!idLogin) return;
    setIsRefreshingGranel(true);
    try {
      await Promise.all([
        recargarGranel(),
        dispatch(obtenerGranelesPorLogin(idLogin)),
        dispatch(obtenerInstalacionesProduccion(idLogin))
      ]);
    } catch (e) {
      console.error("Error al actualizar inventario a granel:", e);
    } finally {
      setTimeout(() => setIsRefreshingGranel(false), 500);
    }
  };

  // Cómputo de registros efectivos de Granel de Envasado conectando con Redux / Backend
  const effectiveGranelRecords = useMemo(() => {
    if (Array.isArray(reduxGranelRecordsEnvasado) && reduxGranelRecordsEnvasado.length > 0) {
      return reduxGranelRecordsEnvasado;
    }

    if (customGranelRecords.length > 0) {
      return customGranelRecords;
    }

    return granelRecords || [];
  }, [reduxGranelRecordsEnvasado, customGranelRecords, granelRecords]);

  // Si Redux carga datos del servidor, limpiar cualquier estado local temporal para evitar filas duplicadas
  useEffect(() => {
    if (Array.isArray(reduxGranelRecordsEnvasado) && reduxGranelRecordsEnvasado.length > 0) {
      setCustomGranelRecords([]);
    }
  }, [reduxGranelRecordsEnvasado]);

  const [noTerminadoRecords, setNoTerminadoRecords] = useState([
    {
      id: "NT-ENV-01",
      fechaMovimiento: "2026-07-16",
      botCaja: "12 botellas",
      marca: "Don Julio Mezcal",
      noLoteGranel: "PROD-LOTE-01",
      loteEnvasado: "L-01-ENV-NT",
      categoria: "Mezcal Artesanal",
      clase: "Joven / Blanco",
      ingrediente: "Maguey Espadín",
      edad: "Sin edad",
      tipoMaguey: "Espadín",
      noAnalisis: "ANA-2026-098",
      capacidad: "750 ml",
      pctAlc: "48.5",
      invInicialCajas: "0",
      invInicialBotellas: "0",
      entradaProcedencia: "Línea de Envasado 1",
      entradaCajas: "50",
      entradaBotellas: "600",
      salidaCajas: "10",
      salidaBotellas: "120",
      salidaDestino: "Área de Etiquetado y Hologramas",
      invFinalCajas: "40",
      invFinalBotellas: "480",
      mermas: "2 botellas (rotura en línea)",
      observaciones: "Envasado inicial de lote sin etiquetar.",
      inspector: "Ing. Carlos Mendoza (16/07/2026)",
      status: "aprobado"
    }
  ]);

  const [terminadoRecords, setTerminadoRecords] = useState([
    {
      id: "T-ENV-01",
      fechaMovimiento: "2026-07-18",
      botCaja: "12 botellas",
      marca: "Don Julio Mezcal",
      noLoteGranel: "PROD-LOTE-01",
      loteEnvasado: "L-01-ENV-T",
      categoria: "Mezcal Artesanal",
      claseEtiqueta: "Joven / Blanco",
      ingredientesEtiqueta: "Maguey Espadín",
      edad: "Sin edad",
      tipoMagueyEtiqueta: "Espadín",
      noAnalisis: "ANA-2026-098",
      capacidad: "750 ml",
      pctAlcEtiqueta: "48.5",
      noInformeAprobacion: "INF-APR-ET-102",
      fechaAprobacionEtiqueta: "2026-07-17",
      invInicialCajas: "0",
      invInicialBotellas: "0",
      entradaProcedencia: "Etiquetado Lote NT-01",
      entradaCajas: "10",
      entradaBotellas: "120",
      salidaCajas: "5",
      salidaBotellas: "60",
      salidaDestino: "Almacén de Producto Terminado",
      invFinalCajas: "5",
      invFinalBotellas: "60",
      observaciones: "Ingreso inicial de botellas con holograma oficial.",
      inspector: "Ing. Carlos Mendoza (18/07/2026)",
      status: "aprobado"
    }
  ]);

  const [hologramaRecords, setHologramaRecords] = useState([
    {
      id: "HOL-01",
      idEnvasadoTerminado: "T-ENV-01",
      fechaMovimiento: "2026-07-18",
      marca: "Don Julio Mezcal",
      loteEnvasado: "L-01-ENV-T",
      capacidad: "750 ml",
      invInicialRango: "A0001 - A0500",
      invInicialCant: "500",
      entradaRango: "N/A",
      entradaCant: "0",
      salidaRango: "A0001 - A0120",
      salidaCant: "120",
      invFinalRango: "A0123 - A0500",
      invFinalCant: "378",
      mermasRango: "A0121 - A0122",
      mermasCant: "2",
      observaciones: "Aplicación inicial de hologramas para primer lote terminado.",
      inspector: "Ing. Carlos Mendoza (18/07/2026)",
      status: "aprobado"
    }
  ]);

  const effectiveNoTerminadoRecords = useMemo(() => {
    if (reduxNoTerminadosLoaded) {
      return Array.isArray(reduxNoTerminados) ? reduxNoTerminados : [];
    }
    return Array.isArray(reduxNoTerminados) && reduxNoTerminados.length > 0 ? reduxNoTerminados : (idLogin ? [] : noTerminadoRecords);
  }, [reduxNoTerminados, reduxNoTerminadosLoaded, noTerminadoRecords, idLogin]);

  const effectiveTerminadoRecords = useMemo(() => {
    const base = reduxTerminadosLoaded
      ? (Array.isArray(reduxTerminados) ? reduxTerminados : [])
      : (Array.isArray(reduxTerminados) && reduxTerminados.length > 0 ? reduxTerminados : (idLogin ? [] : terminadoRecords));

    return base.map(rec => {
      const lote = rec.loteEnvasado || rec.lote_envasado;
      const localMatch = terminadoRecords.find(
        t => (t.id && (t.id === rec.id || t.id === rec.id_bitacora_envasado)) || (lote && (t.loteEnvasado === lote || t.lote_envasado === lote))
      );
      if (localMatch) {
        return {
          ...rec,
          ...localMatch,
          // Lo que ya está en BD (rangos con su estatus, salidas e inventario final) manda sobre la copia local
          rangosHologramas: (rec.rangosHologramas && rec.rangosHologramas.length > 0) ? rec.rangosHologramas : localMatch.rangosHologramas,
          salidaBotellas: rec.salidaBotellas ?? localMatch.salidaBotellas,
          salidaCajas: rec.salidaCajas ?? localMatch.salidaCajas,
          salidaDestino: rec.salidaDestino ?? localMatch.salidaDestino,
          invFinalBotellas: rec.invFinalBotellas ?? localMatch.invFinalBotellas,
          invFinalCajas: rec.invFinalCajas ?? localMatch.invFinalCajas,
          mermas: rec.mermas ?? localMatch.mermas,
          estatus: rec.estatus ?? localMatch.estatus,
          status: rec.status ?? localMatch.status,
        };
      }
      return rec;
    });
  }, [reduxTerminados, reduxTerminadosLoaded, terminadoRecords, idLogin]);

  const effectiveHologramaRecords = useMemo(() => {
    const base = reduxHologramasLoaded
      ? (Array.isArray(reduxHologramas) ? reduxHologramas : [])
      : (Array.isArray(reduxHologramas) && reduxHologramas.length > 0 ? reduxHologramas : (idLogin ? [] : hologramaRecords));

    const recordsWithLocal = (Array.isArray(reduxHologramas) && reduxHologramas.length > 0 && hologramaRecords.length > 0)
      ? base.map(b => {
        const bId = b.id_bitacora_hologramas || b.id;
        const match = hologramaRecords.find(h => (h.id_bitacora_hologramas || h.id) === bId);
        if (match) {
          const movsBase = Array.isArray(b.movimientos) ? b.movimientos : [];
          const movsLocal = Array.isArray(match.movimientos) ? match.movimientos : [];
          const missingMovs = movsLocal.filter(lm => !movsBase.some(bm => (bm.id_movimiento_holograma && bm.id_movimiento_holograma === lm.id_movimiento_holograma) || (bm.id && bm.id === lm.id)));
          if (missingMovs.length > 0 || match.cantidad_disponible !== undefined) {
            return {
              ...b,
              cantidad_disponible: match.cantidad_disponible !== undefined ? match.cantidad_disponible : b.cantidad_disponible,
              invFinalCant: match.invFinalCant !== undefined ? match.invFinalCant : b.invFinalCant,
              cantidad_utilizada: match.cantidad_utilizada !== undefined ? match.cantidad_utilizada : b.cantidad_utilizada,
              salidaCant: match.salidaCant !== undefined ? match.salidaCant : b.salidaCant,
              movimientos: [...movsBase, ...missingMovs]
            };
          }
        }
        return b;
      })
      : base;

    // Calcular en tiempo real consumos contra effectiveTerminadoRecords y movimientos
    return recordsWithLocal.map(rec => {
      const prefijo = (rec.prefijo || "A").trim().toUpperCase();
      const rIni = rec.rango_inicial || rec.rangoInicial || (rec.invInicialRango ? rec.invInicialRango.split("-")[0]?.trim() : "—");
      const rFin = rec.rango_final || rec.rangoFinal || (rec.invInicialRango && rec.invInicialRango.includes("-") ? rec.invInicialRango.split("-")[1]?.trim() : "—");
      const totalInicial = Number(rec.cantidad_inicial ?? rec.cantidadInicial ?? rec.invInicialCant ?? rec.cantidad ?? 0);
      const targetHoloId = rec.id_bitacora_hologramas || rec.id;
      const holoIniNum = parseInt(String(rIni).replace(/\D/g, ""), 10);
      const holoFinNum = parseInt(String(rFin).replace(/\D/g, ""), 10);

      // Salidas de terminados aprobados
      let salidasTerminadosCant = 0;
      (effectiveTerminadoRecords || []).forEach(term => {
        const isAprobado = String(term.status || term.estatus || "").toLowerCase() === "aprobado";
        if (!isAprobado) return;

        const rangos = term.rangosHologramas || term.holograma_rangos || [];
        rangos.forEach(r => {
          const rIniTerm = parseInt(String(r.rango1 || r.rango_inicial || (r.rangoHologramas ? r.rangoHologramas.split("-")[0] : "")).replace(/\D/g, ""), 10);
          const rFinTerm = parseInt(String(r.rango2 || r.rango_final || (r.rangoHologramas ? r.rangoHologramas.split("-")[1] : "")).replace(/\D/g, ""), 10);
          const rPref = (r.prefijo || "A").trim().toUpperCase();

          const hasNumericRange = !isNaN(holoIniNum) && !isNaN(holoFinNum) && !isNaN(rIniTerm) && !isNaN(rFinTerm);
          const rHoloId = r.id_bitacora_hologramas || r.idInventario;

          let isMatch = false;
          if (rHoloId) {
            // Asociación estricta por ID de inventario del lote
            isMatch = String(rHoloId) === String(targetHoloId);
          } else {
            // Solo para registros históricos sin ID de inventario
            const matchesByLote = rec.lote_envasado && term.loteEnvasado && rec.lote_envasado === term.loteEnvasado;
            const matchesExactRange = hasNumericRange && rPref === prefijo && rIniTerm === holoIniNum && rFinTerm === holoFinNum;
            const matchesContainedInLote = matchesByLote && hasNumericRange && rPref === prefijo && rIniTerm >= holoIniNum && rFinTerm <= holoFinNum;
            isMatch = matchesExactRange || matchesContainedInLote;
          }

          if (isMatch) {
            salidasTerminadosCant += Number(r.cantidad || (rFinTerm >= rIniTerm ? rFinTerm - rIniTerm + 1 : 0));
          }
        });
      });

      // Movimientos directos (estrictamente de este id_bitacora_hologramas)
      const directMovs = (Array.isArray(rec.movimientos) ? rec.movimientos : []).filter(m => {
        if (m.tipo_movimiento === "entrada") return false;
        if (m.id_bitacora_hologramas) {
          return String(m.id_bitacora_hologramas) === String(targetHoloId);
        }
        return true;
      });
      const directMovsCant = directMovs.reduce((acc, curr) => acc + (Number(curr.cantidadConsumida || curr.cantidad) || 0), 0);

      const totalSalida = Math.max(
        Number(rec.cantidad_utilizada ?? rec.cantidadUtilizada ?? rec.salidaCant ?? 0),
        salidasTerminadosCant,
        directMovsCant
      );

      const rawDisponible = rec.cantidad_disponible ?? rec.cantidadDisponible ?? rec.invFinalCant;
      const isExplicitAgotado = String(rec.estatus || "").toLowerCase() === "agotado";

      let saldoActual = 0;
      if (!isExplicitAgotado) {
        if (rawDisponible !== undefined && rawDisponible !== null && Number(rawDisponible) < totalInicial) {
          saldoActual = Math.min(Number(rawDisponible), Math.max(0, totalInicial - totalSalida));
        } else {
          saldoActual = Math.max(0, totalInicial - totalSalida);
        }
      }

      return {
        ...rec,
        cantidad_disponible: saldoActual,
        cantidadDisponible: saldoActual,
        invFinalCant: saldoActual,
        cantidad_utilizada: totalSalida,
        cantidadUtilizada: totalSalida,
        salidaCant: totalSalida,
        estatus: saldoActual <= 0 ? "agotado" : (rec.estatus || "activo")
      };
    });
  }, [reduxHologramas, reduxHologramasLoaded, hologramaRecords, idLogin, effectiveTerminadoRecords]);

  const [elaboracionRecords, setElaboracionRecords] = useState([
    {
      id: "ELAB-01",
      fechaIngreso: "2026-07-16",
      loteOrigen: "PROD-LOTE-01",
      volumenOrigen: "700",
      pctAlcOrigen: "48.5",
      categoriaOrigen: "Mezcal Artesanal",
      claseOrigen: "Joven / Blanco",
      ingredientesOrigen: "Maguey Espadín",
      edadOrigen: "Sin edad",
      analisisOrigen: "ANA-2026-098",
      tipoMagueyOrigen: "Espadín",
      ingredientesAdicionados: "Gusano de maguey",
      procesoRealizado: "ABOCADO CON",
      descripcionProceso: "Adición de gusano de maguey deshidratado a lote granel antes del envasado.",
      fechaSalida: "2026-07-17",
      loteSalida: "L-01-ENV-AB",
      volumenSalida: "695",
      pctAlcSalida: "48.2",
      claseSalida: "Abocado con Gusano",
      observaciones: "Filtración leve and adición manual de gusano.",
      inspector: "Ing. Carlos Mendoza (17/07/2026)",
      status: "aprobado"
    }
  ]);

  const [maduracionRecords, setMaduracionRecords] = useState([]);
  const [isMaduracionFormOpen, setIsMaduracionFormOpen] = useState(false);
  const [maduracionFormData, setMaduracionFormData] = useState({
    fechaMovimiento: new Date().toISOString().split("T")[0],
    noLote: "",
    categoria: "Mezcal Artesanal",
    clase: "Blanco Joven",
    tipoMaguey: "",
    noAnalisis: "",
    observaciones: "",
    recipientes: []
  });

  useEffect(() => {
    if (Array.isArray(reduxMaduracionRecords)) {
      setMaduracionRecords(reduxMaduracionRecords);
    }
  }, [reduxMaduracionRecords]);

  // Default pre-filled month for conditions
  const generateDefaultDailyData = () => {
    return Array.from({ length: 31 }).map((_, i) => ({
      dia: i + 1,
      hora: i < 5 ? "09:00" : "",
      temp: i < 5 ? (23 + (i % 3)).toString() : "",
      hum: i < 5 ? (60 - (i % 4)).toString() : ""
    }));
  };

  const [condionesRecords, setCondicionesRecords] = useState([
    {
      mesAnio: "Julio 2026",
      noLote: "PROD-LOTE-01",
      registros: generateDefaultDailyData(),
      observaciones: "Monitoreo correspondiente a los primeros días de maduración en bodega.",
      inspector: "Ing. Carlos Mendoza (19/07/2026)",
      status: "aprobado"
    }
  ]);

  const [quejasRecords, setQuejasRecords] = useState([
    {
      id: 1,
      fechaQueja: "2026-07-10",
      noQueja: "QJ-2026-001",
      noLote: "L-01-ENV-T",
      descripcionProducto: "Don Julio Mezcal - Mezcal Artesanal Joven / Blanco (750 ml)",
      detalleQueja: "El cliente reportó fuga leve de líquido en el tapón de corcho de 2 botellas.",
      fechaAtencion: "2026-07-12",
      medidasCorrectivas: "Se cambiaron los corchos del lote restante por un lote de mayor densidad y se re-inspeccionó el empaque.",
      inspector: "Ing. Carlos Mendoza (12/07/2026)",
      status: "aprobado"
    }
  ]);



  // ================= FORM STATES (SECCION II) =================
  const [fechaMovimiento, setFechaMovimiento] = useState("2026-07-19");
  const [idContenedor, setIdContenedor] = useState("C-10");
  const [noLote, setNoLote] = useState("PROD-LOTE-01");
  const [categoria, setCategoria] = useState("Mezcal Artesanal");
  const [clase, setClase] = useState("Joven / Blanco");
  const [ingrediente, setIngrediente] = useState("Maguey Espadín");
  const [edad, setEdad] = useState("Sin edad");
  const [tipoMaguey, setTipoMaguey] = useState("Espadín");
  const [noAnalisis, setNoAnalisis] = useState("ANA-2026-098");
  const [invInicialVol, setInvInicialVol] = useState("700");
  const [invInicialAlc, setInvInicialAlc] = useState("48.5");
  const [entradaProcedencia, setEntradaProcedencia] = useState("Destilación Lote 02");
  const [entradaVolumen, setEntradaVolumen] = useState("500");
  const [entradaAlc, setEntradaAlc] = useState("48.0");
  const [entradaVolAgua, setEntradaVolAgua] = useState("10");
  const [salidaVolumen, setSalidaVolumen] = useState("0");
  const [salidaAlc, setSalidaAlc] = useState("0.0");
  const [salidaDestino, setSalidaDestino] = useState("N/A");
  const [invFinalVol, setInvFinalVol] = useState("1210");
  const [invFinalAlc, setInvFinalAlc] = useState("47.8");
  const [observaciones, setObservaciones] = useState("");

  // ================= FORM STATES (SECCION III) =================
  const [ntFechaMovimiento, setNtFechaMovimiento] = useState("2026-07-19");
  const [ntBotCaja, setNtBotCaja] = useState("12 botellas");
  const [ntMarca, setNtMarca] = useState("Don Julio Mezcal");
  const [ntNoLoteGranel, setNtNoLoteGranel] = useState("PROD-LOTE-01");
  const [ntVolumenEnvasar, setNtVolumenEnvasar] = useState("750");
  const [ntNoInformeAprobacion, setNtNoInformeAprobacion] = useState("INF-APR-ET-102");
  const [ntLoteEnvasado, setNtLoteEnvasado] = useState("L-01-ENV-NT");
  const [ntCategoria, setNtCategoria] = useState("Mezcal Artesanal");
  const [ntClase, setNtClase] = useState("Joven / Blanco");
  const [ntIngrediente, setNtIngrediente] = useState("Maguey Espadín");
  const [ntEdad, setNtEdad] = useState("Sin edad");
  const [ntTipoMaguey, setNtTipoMaguey] = useState("Espadín");
  const [ntNoAnalisis, setNtNoAnalisis] = useState("ANA-2026-098");
  const [ntCapacidad, setNtCapacidad] = useState("750 ml");
  const [ntPctAlc, setNtPctAlc] = useState("48.5");
  const [ntInvInicialCajas, setNtInvInicialCajas] = useState("40");
  const [ntInvInicialBotellas, setNtInvInicialBotellas] = useState("480");
  const [ntEntradaProcedencia, setNtEntradaProcedencia] = useState("Línea de Envasado 1");
  const [ntEntradaCajas, setNtEntradaCajas] = useState("20");
  const [ntEntradaBotellas, setNtEntradaBotellas] = useState("240");
  const [ntSalidaCajas, setNtSalidaCajas] = useState("15");
  const [ntSalidaBotellas, setNtSalidaBotellas] = useState("180");
  const [ntSalidaDestino, setNtSalidaDestino] = useState("Área de Etiquetado y Hologramas");
  const [ntInvFinalCajas, setNtInvFinalCajas] = useState("45");
  const [ntInvFinalBotellas, setNtInvFinalBotellas] = useState("540");
  const [ntMermas, setNtMermas] = useState("0");
  const [ntObservaciones, setNtObservaciones] = useState("");

  // ================= FORM STATES (SECCION IV) =================
  const [tFechaMovimiento, setTFechaMovimiento] = useState("2026-07-19");
  const [tBotCaja, setTBotCaja] = useState("12 botellas");
  const [tMarca, setTMarca] = useState("Don Julio Mezcal");
  const [tNoLoteGranel, setTNoLoteGranel] = useState("PROD-LOTE-01");
  const [tLoteEnvasado, setTLoteEnvasado] = useState("L-01-ENV-T");
  const [tCategoria, setTCategoria] = useState("Mezcal Artesanal");
  const [tClaseEtiqueta, setTClaseEtiqueta] = useState("Joven / Blanco");
  const [tIngredientesEtiqueta, setTIngredientesEtiqueta] = useState("Maguey Espadín");
  const [tEdad, setTEdad] = useState("Sin edad");
  const [tTipoMagueyEtiqueta, setTTipoMagueyEtiqueta] = useState("Espadín");
  const [tNoAnalisis, setTNoAnalisis] = useState("ANA-2026-098");
  const [tCapacidad, setTCapacidad] = useState("750 ml");
  const [tPctAlcEtiqueta, setTPctAlcEtiqueta] = useState("48.5");
  const [tNoInformeAprobacion, setTNoInformeAprobacion] = useState("INF-APR-ET-102");
  const [tFechaAprobacionEtiqueta, setTFechaAprobacionEtiqueta] = useState("2026-07-17");
  const [tInvInicialCajas, setTInvInicialCajas] = useState("5");
  const [tInvInicialBotellas, setTInvInicialBotellas] = useState("60");
  const [tEntradaProcedencia, setTEntradaProcedencia] = useState("Etiquetado Lote NT-01");
  const [tEntradaCajas, setTEntradaCajas] = useState("15");
  const [tEntradaBotellas, setTEntradaBotellas] = useState("180");
  const [tSalidaCajas, setTSalidaCajas] = useState("10");
  const [tSalidaBotellas, setTSalidaBotellas] = useState("120");
  const [tSalidaDestino, setTSalidaDestino] = useState("Almacén de Producto Terminado");
  const [tInvFinalCajas, setTInvFinalCajas] = useState("10");
  const [tInvFinalBotellas, setTInvFinalBotellas] = useState("120");
  const [tObservaciones, setTObservaciones] = useState("");

  // ================= FORM STATES (SECCION V) =================
  const [hIdEnvasadoTerminado, setHIdEnvasadoTerminado] = useState("T-ENV-01");
  const [hFechaMovimiento, setHFechaMovimiento] = useState("2026-07-19");
  const [hMarca, setHMarca] = useState("Don Julio Mezcal");
  const [hLoteEnvasado, setHLoteEnvasado] = useState("L-01-ENV-T");
  const [hCapacidad, setHCapacidad] = useState("750 ml");
  const [hInvInicialRango, setHInvInicialRango] = useState("A0123 - A0500");
  const [hInvInicialCant, setHInvInicialCant] = useState("378");
  const [hEntradaRango, setHEntradaRango] = useState("B0001 - B0500");
  const [hEntradaCant, setHEntradaCant] = useState("500");
  const [hSalidaRango, setHSalidaRango] = useState("A0123 - A0223");
  const [hSalidaCant, setHSalidaCant] = useState("101");
  const [hInvFinalRango, setHInvFinalRango] = useState("A0224 - A0500, B0001 - B0500");
  const [hInvFinalCant, setHInvFinalCant] = useState("777");
  const [hMermasRango, setHMermasRango] = useState("N/A");
  const [hMermasCant, setHMermasCant] = useState("0");
  const [hObservaciones, setHObservaciones] = useState("");

  // ================= FORM STATES (SECCION VI) =================
  const [elabFechaIngreso, setElabFechaIngreso] = useState("2026-07-19");
  const [elabLoteOrigen, setElabLoteOrigen] = useState("PROD-LOTE-01");
  const [elabVolumenOrigen, setElabVolumenOrigen] = useState("700");
  const [elabPctAlcOrigen, setElabPctAlcOrigen] = useState("48.5");
  const [elabCategoriaOrigen, setElabCategoriaOrigen] = useState("Mezcal Artesanal");
  const [elabClaseOrigen, setElabClaseOrigen] = useState("Joven / Blanco");
  const [elabIngredientesOrigen, setElabIngredientesOrigen] = useState("Maguey Espadín");
  const [elabEdadOrigen, setElabEdadOrigen] = useState("Sin edad");
  const [elabAnalisisOrigen, setElabAnalisisOrigen] = useState("ANA-2026-098");
  const [elabTipoMagueyOrigen, setElabTipoMagueyOrigen] = useState("Espadín");
  const [elabIngredientesAdicionados, setElabIngredientesAdicionados] = useState("Gusano de maguey");
  const [elabProcesoRealizado, setElabProcesoRealizado] = useState("ABOCADO CON");
  const [elabDescripcionProceso, setElabDescripcionProceso] = useState("Proceso de abocado con gusano.");
  const [elabFechaSalida, setElabFechaSalida] = useState("2026-07-19");
  const [elabLoteSalida, setElabLoteSalida] = useState("L-01-ENV-AB");
  const [elabVolumenSalida, setElabVolumenSalida] = useState("695");
  const [elabPctAlcSalida, setElabPctAlcSalida] = useState("48.2");
  const [elabClaseSalida, setElabClaseSalida] = useState("ABOCADO CON");
  const [elabObservaciones, setElabObservaciones] = useState("");

  // ================= FORM STATES (SECCION VII) =================
  const [madFechaMovimiento, setMadFechaMovimiento] = useState("2026-07-19");
  const [madNoLote, setMadNoLote] = useState("PROD-LOTE-01");
  const [madCategoria, setMadCategoria] = useState("Mezcal Artesanal");
  const [madClase, setMadClase] = useState("Joven / Blanco");
  const [madIngredientes, setMadIngredientes] = useState("Maguey Espadín");
  const [madEdad, setMadEdad] = useState("Sin edad");
  const [madTipoMaguey, setMadTipoMaguey] = useState("Espadín");
  const [madNoAnalisis, setMadNoAnalisis] = useState("ANA-2026-098");
  const [madTipoRecipiente, setMadTipoRecipiente] = useState("BARRICAS DE MADERA DE");
  const [madDetalleRecipiente, setMadDetalleRecipiente] = useState("Roble Blanco Americano");
  const [madInvInicialFecha, setMadInvInicialFecha] = useState("2026-07-19");
  const [madInvInicialRecipientes, setMadInvInicialRecipientes] = useState("2");
  const [madInvInicialVolumen, setMadInvInicialVolumen] = useState("400");
  const [madInvInicialAlc, setMadInvInicialAlc] = useState("48.5");
  const [madEntradaFolio, setMadEntradaFolio] = useState("");
  const [madEntradaRecipientes, setMadEntradaRecipientes] = useState("0");
  const [madEntradaVolumen, setMadEntradaVolumen] = useState("0");
  const [madEntradaAlc, setMadEntradaAlc] = useState("0.0");
  const [madSalidaRecipientes, setMadSalidaRecipientes] = useState("1");
  const [madSalidaVolumen, setMadSalidaVolumen] = useState("200");
  const [madSalidaAlc, setMadSalidaAlc] = useState("48.0");
  const [madSalidaClaseObtenida, setMadSalidaClaseObtenida] = useState("Reposado");
  const [madSalidaEdadObtenida, setMadSalidaEdadObtenida] = useState("3 meses");
  const [madSalidaMerma, setMadSalidaMerma] = useState("5");
  const [madInvFinalRecipientes, setMadInvFinalRecipientes] = useState("1");
  const [madInvFinalVolumen, setMadInvFinalVolumen] = useState("195");
  const [madInvFinalAlc, setMadInvFinalAlc] = useState("48.0");
  const [madObservaciones, setMadObservaciones] = useState("");

  // ================= FORM STATES (SECCION VIII) =================
  const [condMesAnio, setCondMesAnio] = useState("Julio 2026");
  const [condNoLote, setCondNoLote] = useState("PROD-LOTE-01");
  const [condDailyData, setCondDailyData] = useState(generateDefaultDailyData());
  const [condObservaciones, setCondObservaciones] = useState("");

  // ================= FORM STATES (SECCION IX) =================
  const [fechaQueja, setFechaQueja] = useState("2026-07-19");
  const [noQueja, setNoQueja] = useState("");
  const [quejaNoLote, setQuejaNoLote] = useState("manual");
  const [descripcionProducto, setDescripcionProducto] = useState("");
  const [detalleQueja, setDetalleQueja] = useState("");
  const [fechaAtencion, setFechaAtencion] = useState("");
  const [medidasCorrectivas, setMedidasCorrectivas] = useState("");
  const [editingGranelId, setEditingGranelId] = useState(null);
  const [granelFormData, setGranelFormData] = useState({
    fechaMovimiento: new Date().toISOString().split("T")[0],
    idContenedor: "",
    noLote: "",
    clave_fq: "",
    especie: "",
    categoria: "Mezcal Artesanal",
    clase: "Blanco Joven",
    ingrediente: "",
    litros: "",
    porcentaje_alc_vol: ""
  });

  const handleOpenNewGranelRecord = () => {
    setEditingGranelId(null);
    setGranelFormData({
      id: null,
      fechaMovimiento: new Date().toISOString().split("T")[0],
      fecha: new Date().toISOString().split("T")[0],
      idContenedor: "",
      no_tanque: "",
      noLote: "",
      no_lote: "",
      categoria: "Mezcal Artesanal",
      clase: "Blanco Joven",
      especie: "",
      tipoMaguey: "",
      ingrediente: "",
      ingredientes: "",
      clave_fq: "",
      noAnalisis: "",
      litros: "",
      porcentaje_alc_vol: "",
      invInicialVol: "0",
      invInicialAlc: "0",
      entradaProcedencia: "Alta Manual Inicial",
      entradaVolumen: "0",
      entradaAlc: "0",
      salidaDestino: "",
      salidaVolumen: "0",
      salidaAlc: "0",
      invFinalVol: "0",
      invFinalAlc: "0",
      observaciones: "",
      origen_registro: "manual",
      status: "borrador"
    });
    setIsFormOpen(true);
  };

  const handleCancelGranel = () => {
    setIsFormOpen(false);
    setEditingGranelId(null);
    setGranelFormData({});
  };

  const handleEditGranelRecord = (rec) => {
    if (rec) {
      const rawSt = String(rec.status || rec.statusUI || rec.estatus || '').toLowerCase();
      const isAprobado = rawSt.includes('aprobad') || rawSt.includes('aceptad') || rawSt === 'activo';
      if (isAprobado) {
        Swal.fire({
          icon: 'info',
          title: 'Registro Dictaminado',
          text: 'Este lote a granel ya fue aprobado por la Unidad de Inspección y se encuentra bloqueado para edición directa.',
          confirmButtonColor: '#059669'
        });
        return;
      }
      setEditingGranelId(rec.id);
      const vol = String(rec.litros ?? rec.invFinalVol ?? rec.entradaVolumen ?? "0").replace(/[^\d.]/g, "");
      const alc = String(rec.porcentaje_alc_vol ?? rec.invFinalAlc ?? rec.entradaAlc ?? "0").replace(/[^\d.]/g, "");
      setGranelFormData({
        id: rec.id || rec.dbId || rec.id_bitacora_granel,
        id_bitacora_granel: rec.id_bitacora_granel || rec.dbId || (typeof rec.id === "number" ? rec.id : null),
        dbId: rec.id_bitacora_granel || rec.dbId || (typeof rec.id === "number" ? rec.id : null),
        fechaMovimiento: rec.fechaMovimiento || rec.fecha || new Date().toISOString().split("T")[0],
        fecha: rec.fecha || rec.fechaMovimiento || new Date().toISOString().split("T")[0],
        idContenedor: rec.idContenedor || rec.no_tanque || "",
        no_tanque: rec.no_tanque || rec.idContenedor || "",
        noLote: rec.noLote || rec.no_lote || rec.noProduccion || "",
        no_lote: rec.no_lote || rec.noLote || rec.noProduccion || "",
        categoria: rec.categoria || "Mezcal Artesanal",
        clase: rec.clase || "Blanco Joven",
        ingredientes: rec.ingredientes || rec.ingrediente || "",
        ingrediente: rec.ingrediente || rec.ingredientes || "",
        tipoMaguey: rec.tipoMaguey || rec.especie || "",
        especie: rec.especie || rec.tipoMaguey || "",
        noAnalisis: rec.noAnalisisFisicoquimico || rec.noAnalisis || rec.clave_fq || "",
        clave_fq: rec.clave_fq || rec.noAnalisisFisicoquimico || rec.noAnalisis || "",
        litros: vol,
        porcentaje_alc_vol: alc,
        invInicialVol: String(rec.invInicialVol || vol).replace(/[^\d.]/g, ""),
        invInicialAlc: String(rec.invInicialAlc || alc).replace(/[^\d.]/g, ""),
        entradaProcedencia: rec.entradaProcedencia || "",
        entradaVolumen: vol,
        entradaAlc: alc,
        salidaDestino: rec.salidaDestino || "",
        salidaVolumen: String(rec.salidaVolumen || "0").replace(/[^\d.]/g, ""),
        salidaAlc: String(rec.salidaAlc || "0").replace(/[^\d.]/g, ""),
        invFinalVol: vol,
        invFinalAlc: alc,
        observaciones: rec.observaciones || "",
        observaciones_correccion: rec.observaciones_correccion || rec.observacionesCorreccion || rec.observaciones_rechazo || "",
        observacionesCorreccion: rec.observaciones_correccion || rec.observacionesCorreccion || rec.observaciones_rechazo || "",
        id_unidad_produccion: rec.id_unidad_produccion || rec.id_anexo_cliente || null,
        id_anexo_cliente: rec.id_anexo_cliente || rec.id_unidad_produccion || null,
        instalacion: rec.instalacion || rec.instalacionOrigen || "",
        instalacionOrigen: rec.instalacion || rec.instalacionOrigen || "",
        origen_registro: rec.origen_registro || "manual",
        id_granel_produccion_origen: rec.id_granel_produccion_origen || null,
        status: rec.status || rec.statusUI || rec.estatus || "borrador",
        statusUI: rec.statusUI || rec.status || rec.estatus || "borrador",
        estatus: rec.estatus || rec.status || rec.statusUI || "borrador"
      });
      setIsFormOpen(true);
    }
  };

  const handleSaveGranel = (statusOrEvent, customStatus = "revision", optionalData = null) => {
    if (statusOrEvent && statusOrEvent.preventDefault) statusOrEvent.preventDefault();
    const activeData = optionalData || (typeof customStatus === "object" ? customStatus : null) || granelFormData || {};

    const targetLote = activeData.noLote || activeData.no_lote || `GRANEL-ENV-${Date.now().toString().slice(-4)}`;
    const finalStatus = typeof customStatus === "string" ? customStatus : (activeData.status || activeData.estatus || "revision");
    const isBorrador = finalStatus === "borrador";
    const isRechazado = finalStatus === "rechazado";
    const isAprobado = finalStatus === "aprobado";
    const statusUI = isBorrador ? "borrador" : (isRechazado ? "rechazado" : (isAprobado ? "aprobado" : "revision"));

    const volMezcal = String(activeData.litros || activeData.invFinalVol || activeData.entradaVolumen || "0").replace(/[^\d.]/g, "");
    const alcMezcal = String(activeData.porcentaje_alc_vol || activeData.invFinalAlc || activeData.entradaAlc || "0").replace(/[^\d.]/g, "");

    const newGranelRecord = {
      id: activeData.id || `GRA-ENV-${Date.now().toString().slice(-4)}`,
      id_bitacora_granel: activeData.id_bitacora_granel || activeData.dbId || (typeof activeData.id === "number" ? activeData.id : null),
      dbId: activeData.dbId || activeData.id_bitacora_granel || (typeof activeData.id === "number" ? activeData.id : null),
      noLote: targetLote,
      no_lote: targetLote,
      noProduccion: targetLote,
      idContenedor: activeData.idContenedor || activeData.no_tanque || "-",
      no_tanque: activeData.no_tanque || activeData.idContenedor || "-",
      categoria: activeData.categoria || "Mezcal Artesanal",
      clase: activeData.clase || "Blanco Joven",
      fechaMovimiento: activeData.fechaMovimiento || activeData.fecha || new Date().toISOString().split("T")[0],
      fecha: activeData.fecha || activeData.fechaMovimiento || new Date().toISOString().split("T")[0],
      noAnalisisFisicoquimico: activeData.clave_fq || activeData.noAnalisis || "",
      noAnalisis: activeData.clave_fq || activeData.noAnalisis || "",
      clave_fq: activeData.clave_fq || activeData.noAnalisis || "",
      tipoMaguey: activeData.especie || activeData.tipoMaguey || "",
      especie: activeData.especie || activeData.tipoMaguey || "",
      materiaPrima: activeData.especie || activeData.tipoMaguey || "",
      ingredientes: activeData.ingredientes || activeData.ingrediente || "",
      ingrediente: activeData.ingrediente || activeData.ingredientes || "",
      litros: parseFloat(volMezcal) || 0,
      porcentaje_alc_vol: parseFloat(alcMezcal) || 0,
      invInicialVol: volMezcal,
      invInicialAlc: alcMezcal,
      entradaProcedencia: activeData.entradaProcedencia || (activeData.origen_registro === "produccion" ? `Traslado desde Producción (Lote ${targetLote})` : "Alta Manual Inicial"),
      entradaVolumen: volMezcal,
      entradaAlc: alcMezcal,
      salidaDestino: activeData.salidaDestino || "",
      salidaVolumen: String(activeData.salidaVolumen || "0").replace(/[^\d.]/g, ""),
      salidaAlc: String(activeData.salidaAlc || "0").replace(/[^\d.]/g, ""),
      invFinalVol: volMezcal,
      invFinalAlc: alcMezcal,
      observaciones: activeData.observaciones || "Ingreso a inventario de mezcal a granel para envasado.",
      observaciones_correccion: activeData.observaciones_correccion || activeData.observacionesCorreccion || null,
      observacionesCorreccion: activeData.observaciones_correccion || activeData.observacionesCorreccion || null,
      inspector: activeData.inspector || "Pendiente de Asignación UI",
      id_anexo_cliente: activeData.id_anexo_cliente || activeData.id_unidad_produccion || null,
      id_unidad_produccion: activeData.id_unidad_produccion || activeData.id_anexo_cliente || null,
      instalacion: activeData.instalacion || activeData.instalacionOrigen || "",
      origen_registro: activeData.origen_registro || (activeData.id_granel_produccion_origen ? "produccion" : "manual"),
      id_granel_produccion_origen: activeData.id_granel_produccion_origen || null,
      status: finalStatus,
      statusUI: statusUI,
      estatus: finalStatus
    };

    setIsFormOpen(false);
    setGranelFormData({});

    if (idLogin) {
      const payloadBackend = {
        id_login: idLogin,
        no_lote: targetLote,
        no_tanque: newGranelRecord.no_tanque,
        categoria: newGranelRecord.categoria,
        clase: newGranelRecord.clase,
        especie: newGranelRecord.especie,
        ingrediente: newGranelRecord.ingrediente,
        litros: newGranelRecord.litros,
        porcentaje_alc_vol: newGranelRecord.porcentaje_alc_vol,
        fecha: newGranelRecord.fecha,
        estatus: finalStatus,
        observaciones: newGranelRecord.observaciones,
        clave_fq: newGranelRecord.clave_fq,
        id_anexo_cliente: newGranelRecord.id_anexo_cliente,
        origen_registro: newGranelRecord.origen_registro,
        id_granel_produccion_origen: newGranelRecord.id_granel_produccion_origen
      };

      const targetDbId = activeData.id_bitacora_granel || activeData.dbId || (typeof activeData.id === "number" ? activeData.id : null);
      if (targetDbId) {
        dispatch(actualizarGranelEnvasado({ id: targetDbId, granelData: payloadBackend })).then(() => {
          recargarGranel();
        });
      } else {
        dispatch(registrarGranelEnvasado(payloadBackend)).then(() => {
          recargarGranel();
        });
      }
    } else {
      setCustomGranelRecords(prev => {
        const idx = prev.findIndex(r => r.id === newGranelRecord.id || (r.noLote && r.noLote === newGranelRecord.noLote));
        if (idx >= 0) {
          const copy = [...prev];
          copy[idx] = newGranelRecord;
          return copy;
        }
        return [newGranelRecord, ...prev];
      });
    }

    Swal.fire({
      icon: "success",
      title: isBorrador ? "¡Borrador Guardado!" : "¡Movimiento Enviado a Revisión UI!",
      html: `El registro de mezcal a granel para el lote <b>${targetLote}</b> en <b>${newGranelRecord.no_tanque}</b> ha sido guardado exitosamente ${isBorrador ? "en estatus Borrador." : "y enviado a validación de la Unidad de Inspección."}`,
      confirmButtonColor: "#059669"
    });
  };

  const handleSaveFusion = (newGranelData, validSources, finalStatus = "revision") => {
    if (idLogin) {
      const payloadBackend = {
        id_login: idLogin,
        no_lote: newGranelData.noLote,
        no_tanque: newGranelData.idContenedor || newGranelData.no_tanque,
        categoria: newGranelData.categoria,
        clase: newGranelData.clase,
        especie: newGranelData.tipoMaguey || newGranelData.especie,
        ingrediente: newGranelData.ingredientes || newGranelData.ingrediente,
        litros: parseFloat(newGranelData.invFinalVol) || 0,
        porcentaje_alc_vol: parseFloat(newGranelData.invFinalAlc) || 0,
        fecha: newGranelData.fechaMovimiento || newGranelData.fecha || new Date().toISOString(),
        estatus: finalStatus,
        observaciones: newGranelData.observaciones || "",
        fuentes: validSources.map(s => ({
          id_granel_origen: s.id || s.id_bitacora_granel || null,
          granelId: s.granelId,
          volExtraer: parseFloat(s.volExtraer) || 0,
          no_lote_origen: s.noLote || s.granelId
        }))
      };

      dispatch(registrarFusionGranelEnvasado(payloadBackend)).then(() => {
        recargarGranel();
      });
    } else {
      // 1. Descontar volúmenes extraídos en los registros origen (modo demo)
      setCustomGranelRecords(prev => {
        const updatedExisting = prev.map(rec => {
          const matchingSrc = validSources.find(s => s.granelId === rec.id || s.granelId === rec.noLote || s.granelId === rec.idContenedor);
          if (matchingSrc) {
            const extraido = parseFloat(matchingSrc.volExtraer) || 0;
            const currentFinal = parseFloat(String(rec.invFinalVol || rec.entradaVolumen || rec.litros || 0).replace(/[^\d.]/g, "")) || 0;
            const newFinal = Math.max(0, currentFinal - extraido);
            const currentSalida = parseFloat(String(rec.salidaVolumen || 0).replace(/[^\d.]/g, "")) || 0;
            const motivo = validSources.length === 1
              ? `Extracción a nuevo lote: ${newGranelData.noLote}`
              : `Extracción para mezcla: ${newGranelData.noLote}`;

            return {
              ...rec,
              salidaDestino: rec.salidaDestino ? `${rec.salidaDestino} | ${motivo}` : motivo,
              salidaVolumen: String(currentSalida + extraido),
              invFinalVol: String(newFinal),
              litros: newFinal
            };
          }
          return rec;
        });

        return [newGranelData, ...updatedExisting];
      });
    }

    Swal.fire({
      icon: "success",
      title: "¡Fusión / Mezcla Registrada!",
      html: `El lote resultante <b>${newGranelData.noLote}</b> ha sido registrado y los volúmenes correspondientes han sido descontados.`,
      confirmButtonColor: "#059669"
    });
  };

  const handleUndoGranel = (recordToUndo) => {
    if (!recordToUndo) return;
    const isBorrador = String(recordToUndo.status || recordToUndo.statusUI || "").toLowerCase().includes("borrador");
    if (!isBorrador) {
      Swal.fire({
        title: "Operación no permitida",
        text: "Solo es posible deshacer movimientos que se encuentren en estado de Borrador.",
        icon: "warning",
        confirmButtonColor: "#7C3AED"
      });
      return;
    }

    Swal.fire({
      title: "¿Deshacer movimiento en borrador?",
      html: `Está a punto de cancelar y deshacer el registro en borrador del lote <strong>${recordToUndo.noLote || recordToUndo.idContenedor || "Granel"}</strong>.<br/>Esta acción devolverá los saldos de volumen inmediatamente.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DC2626",
      cancelButtonColor: "#64748B",
      confirmButtonText: "Sí, deshacer y regresar volumen",
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (!result.isConfirmed) return;

      const targetId = recordToUndo.id_bitacora_granel || recordToUndo.id;
      if (targetId) {
        dispatch(deshacerMovimientoGranelEnvasado(targetId)).then(() => {
          recargarGranel();
        });
      }

      setCustomGranelRecords(prev => prev.filter(r => r.id !== recordToUndo.id && r.noLote !== recordToUndo.noLote));

      Swal.fire({
        title: "¡Movimiento Deshecho!",
        text: "El movimiento ha sido deshecho y el inventario restituido exitosamente.",
        icon: "success",
        confirmButtonColor: "#059669"
      });
    });
  };

  const handleSaveTraslado = (trasladoData) => {
    if (!trasladoData) return;
    const vol = parseFloat(trasladoData.volumen || trasladoData.litros_traslado || 0);

    if (idLogin) {
      dispatch(registrarTrasladoGranelEnvasado({ ...trasladoData, id_login: idLogin })).then(() => {
        recargarGranel();
      });
    } else {
      setCustomGranelRecords(prev => {
        return prev.map(rec => {
          if (rec.id === trasladoData.id_granel_origen || rec.noLote === trasladoData.no_lote_origen) {
            const newMov = {
              id_movimiento: Date.now(),
              tipo_movimiento: "traslado",
              litros_transferidos: vol,
              porcentaje_alc_vol: parseFloat(rec.porcentaje_alc_vol || 0),
              instalacion_origen: rec.instalacion || "Instalación Origen",
              instalacion_destino: trasladoData.instalacion_destino || "",
              folio_documento: trasladoData.folio_documento || "",
              motivo: `Traslado pendiente de validación UI: hacia ${trasladoData.instalacion_destino || "otra instalación"}`,
              fecha: trasladoData.fecha || new Date().toISOString().split("T")[0],
              observaciones: trasladoData.observaciones || "",
              es_pendiente: true,
              estado_ui: "Pendiente UI"
            };
            return {
              ...rec,
              estatus: "revision",
              status: "revision",
              statusUI: "revision",
              tieneTrasladoPendiente: true,
              trasladoPendiente: newMov,
              movimientos: [newMov, ...(Array.isArray(rec.movimientos) ? rec.movimientos : [])]
            };
          }
          return rec;
        });
      });
    }

    Swal.fire({
      icon: "success",
      title: "¡Solicitud de Traslado Registrada!",
      html: `Se registró la solicitud de traslado de <b>${vol} L</b> a <b>${trasladoData.instalacion_destino}</b>. Queda pendiente de validación de la UI.`,
      confirmButtonColor: "#2563EB"
    });
  };

  const handleSaveDilucion = (dilucionData) => {
    if (!dilucionData) return;
    const agua = parseFloat(dilucionData.agua_agregada || 0);
    const grado = parseFloat(dilucionData.grado_objetivo || 0);

    if (idLogin) {
      dispatch(registrarDilucionGranelEnvasado({ ...dilucionData, id_login: idLogin })).then(() => {
        recargarGranel();
      });
    } else {
      setCustomGranelRecords(prev => {
        return prev.map(rec => {
          if (rec.id === dilucionData.id_granel_origen || rec.noLote === dilucionData.no_lote_origen) {
            const newMov = {
              id_movimiento: Date.now(),
              tipo_movimiento: "dilucion",
              agua_agregada: agua,
              grado_obtenido: grado,
              litros_transferidos: agua,
              porcentaje_alc_vol: parseFloat(rec.porcentaje_alc_vol || 0),
              folio_documento: dilucionData.lote_agua || "",
              motivo: "Dilución pendiente de validación UI",
              fecha: dilucionData.fecha || new Date().toISOString().split("T")[0],
              observaciones: dilucionData.observaciones || "",
              es_pendiente: true,
              estado_ui: "Pendiente UI"
            };
            return {
              ...rec,
              estatus: "revision",
              status: "revision",
              statusUI: "revision",
              tieneDilucionPendiente: true,
              dilucionPendiente: newMov,
              movimientos: [newMov, ...(Array.isArray(rec.movimientos) ? rec.movimientos : [])]
            };
          }
          return rec;
        });
      });
    }

    Swal.fire({
      icon: "success",
      title: "¡Solicitud de Dilución Registrada!",
      html: `Se registraron <b>${agua} L</b> de agua para ajuste a <b>${grado}%</b> Alc. Vol. Queda pendiente de validación UI.`,
      confirmButtonColor: "#0D9488"
    });
  };

  const handleSaveBaja = (bajaData) => {
    if (!bajaData) return;
    const vol = parseFloat(bajaData.litros_baja || 0);

    if (idLogin) {
      dispatch(registrarBajaGranelEnvasado({ ...bajaData, id_login: idLogin })).then(() => {
        recargarGranel();
      });
    } else {
      setCustomGranelRecords(prev => {
        return prev.map(rec => {
          if (rec.id === bajaData.id_granel_origen || rec.noLote === bajaData.no_lote_origen) {
            const newMov = {
              id_movimiento: Date.now(),
              tipo_movimiento: "baja",
              litros_transferidos: vol,
              porcentaje_alc_vol: parseFloat(rec.porcentaje_alc_vol || 0),
              folio_documento: bajaData.folio_documento || "",
              motivo: `Baja/Egreso pendiente de validación UI: ${bajaData.motivo || "Merma"}`,
              fecha: bajaData.fecha || new Date().toISOString().split("T")[0],
              observaciones: bajaData.observaciones || "",
              es_pendiente: true,
              estado_ui: "Pendiente UI"
            };
            return {
              ...rec,
              estatus: "revision",
              status: "revision",
              statusUI: "revision",
              tieneBajaPendiente: true,
              bajaPendiente: newMov,
              movimientos: [newMov, ...(Array.isArray(rec.movimientos) ? rec.movimientos : [])]
            };
          }
          return rec;
        });
      });
    }

    Swal.fire({
      icon: "success",
      title: "¡Solicitud de Baja Registrada!",
      html: `Se registró la baja de <b>${vol} L</b> por concepto de <b>${bajaData.motivo || "Merma"}</b>. En espera de validación UI.`,
      confirmButtonColor: "#EA580C"
    });
  };

  const handleSaveMuestreo = (muestreoData) => {
    if (!muestreoData) return;
    const vol = parseFloat(muestreoData.litros_muestra || 0);

    if (idLogin) {
      dispatch(registrarMuestreoGranelEnvasado({ ...muestreoData, id_login: idLogin })).then(() => {
        recargarGranel();
      });
    } else {
      setCustomGranelRecords(prev => {
        return prev.map(rec => {
          if (rec.id === muestreoData.id_granel_origen || rec.noLote === muestreoData.no_lote_origen) {
            const newMov = {
              id_movimiento: Date.now(),
              tipo_movimiento: "muestreo",
              litros_transferidos: vol,
              porcentaje_alc_vol: parseFloat(rec.porcentaje_alc_vol || 0),
              folio_documento: muestreoData.folio_documento || "",
              motivo: `Muestreo pendiente de validación UI: ${muestreoData.tipo_muestreo || "Oficial"}`,
              fecha: muestreoData.fecha || new Date().toISOString().split("T")[0],
              observaciones: muestreoData.observaciones || "",
              es_pendiente: true,
              estado_ui: "Pendiente UI"
            };
            return {
              ...rec,
              estatus: "revision",
              status: "revision",
              statusUI: "revision",
              tieneMuestreoPendiente: true,
              muestreoPendiente: newMov,
              movimientos: [newMov, ...(Array.isArray(rec.movimientos) ? rec.movimientos : [])]
            };
          }
          return rec;
        });
      });
    }

    Swal.fire({
      icon: "success",
      title: "¡Extracción de Muestra Registrada!",
      html: `Se registró la muestra de <b>${vol} L</b> para <b>${muestreoData.tipo_muestreo || "Análisis"}</b>. En espera de validación UI.`,
      confirmButtonColor: "#4F46E5"
    });
  };

  const handleSaveNoTerminado = (status, extraData = {}) => {
    const rangos = rangosParaEnviar(extraData.rangosHologramas || []);
    const tieneHologramas = rangos.some(
      r => String(r.rango1 || "").trim() !== "" &&
        String(r.rango2 || "").trim() !== "" &&
        parseInt(r.cantidad || 0, 10) > 0
    );

    // BIFURCACIÓN:
    // Si agrega rango de hologramas -> Pasa directamente a TERMINADO (Sección IV)
    // Si no agrega nada en hologramas -> Se queda como NO TERMINADO (Sección III)
    if (tieneHologramas) {
      const newTerminado = {
        id: `T-ENV-0${terminadoRecords.length + 1}`,
        idNoTerminadoOrigen: `NT-ENV-0${noTerminadoRecords.length + 1}`,
        fechaMovimiento: ntFechaMovimiento || new Date().toISOString().split("T")[0],
        botCaja: ntBotCaja,
        marca: ntMarca,
        noLoteGranel: ntNoLoteGranel,
        volumenEnvasar: ntVolumenEnvasar,
        loteEnvasado: ntLoteEnvasado,
        categoria: ntCategoria,
        claseEtiqueta: ntClase,
        ingredientesEtiqueta: ntIngrediente,
        edad: ntEdad,
        tipoMagueyEtiqueta: ntTipoMaguey,
        noAnalisis: ntNoAnalisis,
        capacidad: ntCapacidad,
        pctAlcEtiqueta: ntPctAlc,
        noInformeAprobacion: ntNoInformeAprobacion || "INF-APR-ENV",
        fechaAprobacionEtiqueta: ntFechaMovimiento || new Date().toISOString().split("T")[0],
        invInicialCajas: ntInvInicialCajas || "0",
        invInicialBotellas: ntInvInicialBotellas || "0",
        entradaProcedencia: ntEntradaProcedencia || `Línea de Envasado con Hologramas (${ntLoteEnvasado})`,
        entradaCajas: ntEntradaCajas || "0",
        entradaBotellas: ntEntradaBotellas || "0",
        salidaCajas: extraData.salidaCajas !== undefined ? String(extraData.salidaCajas) : (ntSalidaCajas || "0"),
        salidaBotellas: extraData.salidaBotellas !== undefined ? String(extraData.salidaBotellas) : (ntSalidaBotellas || "0"),
        salidaDestino: extraData.salidaDestino || ntSalidaDestino || "Almacén de Producto Terminado",
        invFinalCajas: extraData.invFinalCajas !== undefined ? String(extraData.invFinalCajas) : (ntInvFinalCajas || "0"),
        invFinalBotellas: extraData.invFinalBotellas !== undefined ? String(extraData.invFinalBotellas) : (ntInvFinalBotellas || "0"),
        observaciones: ntObservaciones || "Envasado Terminado con Hologramas Asignados",
        inspector: "Pendiente de V.Bo.",
        status: status || "revision",
        rangosHologramas: rangos,
        totalHologramas: extraData.totalHologramas || 0,
        hologramasIncorporados: false
      };


      if (idLogin) {
        dispatch(registrarEnvasadoProducto({
          id_login: idLogin,
          fecha_movimiento: ntFechaMovimiento || new Date().toISOString().split("T")[0],
          bot_caja: ntBotCaja,
          marca: ntMarca,
          no_lote_granel: ntNoLoteGranel,
          volumen_envasar: ntVolumenEnvasar,
          lote_envasado: ntLoteEnvasado,
          categoria: ntCategoria,
          clase: ntClase,
          ingrediente: ntIngrediente,
          edad: ntEdad,
          tipo_maguey: ntTipoMaguey,
          no_analisis: ntNoAnalisis,
          capacidad: ntCapacidad,
          pct_alc: ntPctAlc,
          no_informe_aprobacion: ntNoInformeAprobacion || "INF-APR-ENV",
          fecha_aprobacion_etiqueta: ntFechaMovimiento || new Date().toISOString().split("T")[0],
          inv_inicial_cajas: ntInvInicialCajas || 0,
          inv_inicial_botellas: ntInvInicialBotellas || 0,
          entrada_cajas: ntEntradaCajas || 0,
          entrada_botellas: ntEntradaBotellas || 0,
          entrada_procedencia: ntEntradaProcedencia || `Línea de Envasado con Hologramas (${ntLoteEnvasado})`,
          salida_cajas: extraData.salidaCajas !== undefined ? Number(extraData.salidaCajas) : (ntSalidaCajas || 0),
          salida_botellas: extraData.salidaBotellas !== undefined ? Number(extraData.salidaBotellas) : (ntSalidaBotellas || 0),
          salida_destino: extraData.salidaDestino || ntSalidaDestino || "Almacén de Producto Terminado",
          inv_final_cajas: extraData.invFinalCajas !== undefined ? Number(extraData.invFinalCajas) : (ntInvFinalCajas || 0),
          inv_final_botellas: extraData.invFinalBotellas !== undefined ? Number(extraData.invFinalBotellas) : (ntInvFinalBotellas || 0),
          mermas: extraData.mermas !== undefined ? Number(extraData.mermas) : (ntMermas || 0),
          observaciones: ntObservaciones || "Envasado Terminado con Hologramas Asignados",
          estado_proceso: "terminado",
          estatus: status || "revision",
          rangosHologramas: rangos,
        })).then(async (res) => {
          const loteGuardado = res?.payload?.data || res?.payload;
          await subirDocumentosPendientesDeRangos(extraData.rangosHologramas || [], loteGuardado, idLogin);
          await subirDocumentosPendientesDeSalidas(extraData.rangosHologramas || [], loteGuardado, idLogin);
          dispatch(obtenerEnvasadosTerminadosPorLogin(idLogin));
          dispatch(obtenerEnvasadosNoTerminadosPorLogin(idLogin));
        });
      }

      setTerminadoRecords(prev => [...prev, newTerminado]);
      setIsFormOpen(false);

      Swal.fire({
        icon: "success",
        title: "¡Pasa a Envasado Terminado!",
        html: `Al haber asignado rango(s) de hologramas en el Punto 4, el lote <strong>${ntLoteEnvasado}</strong> pasa directamente a <strong>Envasado Terminado (Sección IV)</strong>.<br/><br/>Estatus: <strong>En revisión (Pendiente de V.Bo. de Unidad de Inspección)</strong>.<br/><br/><em>Nota: Cuando el inspector valide este lote, sus rangos de hologramas pasarán automáticamente al Inventario de Control de Hologramas (Sección V).</em>`,
        confirmButtonColor: "#6B21A8"
      });
    } else {
      const newRecord = {
        id: `NT-ENV-0${noTerminadoRecords.length + 1}`,
        fechaMovimiento: ntFechaMovimiento || new Date().toISOString().split("T")[0],
        botCaja: ntBotCaja,
        marca: ntMarca,
        noLoteGranel: ntNoLoteGranel,
        volumenEnvasar: ntVolumenEnvasar,
        noInformeAprobacion: ntNoInformeAprobacion,
        loteEnvasado: ntLoteEnvasado,
        categoria: ntCategoria,
        clase: ntClase,
        ingrediente: ntIngrediente,
        edad: ntEdad,
        tipoMaguey: ntTipoMaguey,
        noAnalisis: ntNoAnalisis,
        capacidad: ntCapacidad,
        pctAlc: ntPctAlc,
        invInicialCajas: ntInvInicialCajas,
        invInicialBotellas: ntInvInicialBotellas,
        entradaProcedencia: ntEntradaProcedencia,
        entradaCajas: ntEntradaCajas,
        entradaBotellas: ntEntradaBotellas,
        salidaCajas: ntSalidaCajas,
        salidaBotellas: ntSalidaBotellas,
        salidaDestino: ntSalidaDestino,
        invFinalCajas: ntInvFinalCajas,
        invFinalBotellas: ntInvFinalBotellas,
        mermas: ntMermas || "0",
        rangosHologramas: [],
        observaciones: ntObservaciones || "Sin observaciones.",
        inspector: "Pendiente de V.Bo.",
        status: status || "revision",
        estadoProceso: "no_terminado"
      };

      if (idLogin) {
        dispatch(registrarEnvasadoProducto({
          id_login: idLogin,
          fecha_movimiento: ntFechaMovimiento || new Date().toISOString().split("T")[0],
          bot_caja: ntBotCaja,
          marca: ntMarca,
          no_lote_granel: ntNoLoteGranel,
          volumen_envasar: ntVolumenEnvasar,
          lote_envasado: ntLoteEnvasado,
          categoria: ntCategoria,
          clase: ntClase,
          ingrediente: ntIngrediente,
          edad: ntEdad,
          tipo_maguey: ntTipoMaguey,
          no_analisis: ntNoAnalisis,
          capacidad: ntCapacidad,
          pct_alc: ntPctAlc,
          no_informe_aprobacion: ntNoInformeAprobacion,
          inv_inicial_cajas: ntInvInicialCajas || 0,
          inv_inicial_botellas: ntInvInicialBotellas || 0,
          entrada_cajas: ntEntradaCajas || 0,
          entrada_botellas: ntEntradaBotellas || 0,
          entrada_procedencia: ntEntradaProcedencia,
          salida_cajas: ntSalidaCajas || 0,
          salida_botellas: ntSalidaBotellas || 0,
          salida_destino: ntSalidaDestino,
          inv_final_cajas: ntInvFinalCajas || 0,
          inv_final_botellas: ntInvFinalBotellas || 0,
          mermas: ntMermas || 0,
          observaciones: ntObservaciones || "Sin observaciones.",
          estado_proceso: "no_terminado",
          estatus: status || "revision",
          rangosHologramas: []
        })).then(() => {
          dispatch(obtenerEnvasadosNoTerminadosPorLogin(idLogin));
        });
      }

      setNoTerminadoRecords(prev => [...prev, newRecord]);
      setIsFormOpen(false);

      Swal.fire({
        icon: "info",
        title: "Envasado No Terminado",
        html: `Al no contar con rango de hologramas, el lote <strong>${ntLoteEnvasado}</strong> se conserva en <strong>Envasado No Terminado (Botella sin Etiquetar - Sección III)</strong>.<br/><br/>Estatus: <strong>En revisión (Pendiente de V.Bo. de Unidad de Inspección)</strong>.`,
        confirmButtonColor: "#C2410C"
      });
    }
  };

  // VALIDACIÓN DEL INSPECTOR PARA PRODUCTO TERMINADO (SECCIÓN IV)
  // Al validar: el estatus pasa a 'aprobado' en DB y los folios de hologramas se descuentan del inventario de Sección V
  // VALIDACIÓN DEL INSPECTOR PARA PRODUCTO TERMINADO (SECCIÓN IV)
  // Al validar: el estatus pasa a 'aprobado' en DB y los folios de hologramas se descuentan del inventario de Sección V
  const handleValidarInspectorTerminado = (record) => {
    if (!record) return;

    Swal.fire({
      title: "¿Validar Lote de Envasado Terminado?",
      html: `¿Desea otorgar el <strong>V.Bo. de Inspector de la Unidad de Inspección</strong> al lote <strong>${record.loteEnvasado}</strong> (${record.marca})?<br/><br/>Esta acción aprobará el lote y descontará los folios de hologramas del <strong>Inventario de Control de Hologramas (Sección V)</strong> registrando el movimiento aprobado en su historial.`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#059669",
      cancelButtonColor: "#64748B",
      confirmButtonText: "Sí, Validar y Otorgar V.Bo.",
      cancelButtonText: "Cancelar"
    }).then(async (result) => {
      if (result.isConfirmed) {
        const targetId = record.id_bitacora_envasado || record.id;
        const inspectorNombre = "Ing. Inspector COMERCAM (V.Bo.)";
        const fechaAprobacion = new Date().toISOString().split("T")[0];

        // 1. Actualizar el registro terminado localmente a 'aprobado'
        setTerminadoRecords(prev =>
          prev.map(item =>
            (item.id === record.id || (targetId && item.id_bitacora_envasado === targetId))
              ? { ...item, status: "aprobado", estatus: "aprobado", inspector: `${inspectorNombre} - ${fechaAprobacion}`, hologramasIncorporados: true, observaciones_correccion: null }
              : item
          )
        );

        // 2. Extraer rangos de hologramas asignados y descontar + registrar movimiento tanto localmente como en backend
        const rangos = (record.rangosHologramas && record.rangosHologramas.length > 0)
          ? record.rangosHologramas
          : (record.holograma_rangos || []);

        for (const r of rangos) {
          const cantHolo = parseInt(r.cantidad || r.cantidadInicial || 0, 10);
          if (cantHolo > 0) {
            const holoInventoryId = r.id_bitacora_hologramas || r.idInventario;
            const targetPrefijo = (r.prefijo || "A").trim().toUpperCase();
            const rIni = r.rango1 ? `${targetPrefijo}${r.rango1}` : (r.rango_inicial || `${targetPrefijo}0`);
            const rFin = r.rango2 ? `${targetPrefijo}${r.rango2}` : (r.rango_final || `${targetPrefijo}0`);
            const rComp = r.rangoHologramas || `${rIni} - ${rFin}`;

            // Actualizar inventario localmente en hologramaRecords
            setHologramaRecords(prev => prev.map(h => {
              const hId = h.id_bitacora_hologramas || h.id;
              const matchesById = holoInventoryId && String(hId) === String(holoInventoryId);
              const matchesByRango = !holoInventoryId && (h.rango_completo === rComp || h.invInicialRango === rComp);
              if (matchesById || matchesByRango) {
                const prevDisp = (h.cantidad_disponible !== undefined && h.cantidad_disponible !== null)
                  ? Number(h.cantidad_disponible)
                  : (h.invFinalCant !== undefined ? Number(h.invFinalCant) : Number(h.cantidad_inicial || 0));
                const newDisp = Math.max(0, prevDisp - cantHolo);
                const prevSalida = Number(h.salidaCant || h.cantidad_utilizada || 0);
                const newSalida = prevSalida + cantHolo;

                const nuevoMov = {
                  id_movimiento_holograma: Date.now() + Math.floor(Math.random() * 1000),
                  id: `MOV-${Date.now()}-${Math.floor(Math.random() * 1000)}`,
                  id_bitacora_hologramas: holoInventoryId || hId,
                  fecha: fechaAprobacion,
                  tipo_movimiento: "salida_adherido",
                  rangoConsumido: rComp,
                  rango_completo: rComp,
                  cantidadConsumida: cantHolo,
                  cantidad: cantHolo,
                  rangoMermas: "N/A",
                  rango_mermas: "N/A",
                  cantidadMermada: 0,
                  cantidad_mermada: 0,
                  saldoRestanteCant: newDisp,
                  saldo_restante: newDisp,
                  motivo: `Adherido a lote terminado ${record.loteEnvasado}`,
                  observaciones: `Validado por Unidad de Inspección - Lote ${record.loteEnvasado} (${record.marca || ""})`,
                  estatus: "aprobado",
                  loteEnvasado: record.loteEnvasado,
                  marca: record.marca
                };

                return {
                  ...h,
                  cantidad_disponible: newDisp,
                  invFinalCant: newDisp,
                  cantidad_utilizada: newSalida,
                  salidaCant: newSalida,
                  salidaRango: rComp,
                  movimientos: [...(h.movimientos || []), nuevoMov]
                };
              }
              return h;
            }));

            // Si hay sesión de usuario, registrar el movimiento en el backend
            if (idLogin) {
              try {
                await dispatch(registrarMovimientoHolograma({
                  id_bitacora_hologramas: holoInventoryId || null,
                  id_bitacora_envasado: targetId || null,
                  id_login: idLogin,
                  fecha: fechaAprobacion,
                  tipo_movimiento: "salida_adherido",
                  prefijo: targetPrefijo,
                  rango_inicial: r.rango1 || null,
                  rango_final: r.rango2 || null,
                  rango_completo: rComp,
                  cantidad: cantHolo,
                  motivo: `Adherido a lote terminado ${record.loteEnvasado}`,
                  observaciones: `Validado por Unidad de Inspección - Lote ${record.loteEnvasado} (${record.marca || ""})`
                })).unwrap();
              } catch (movErr) {
                console.warn("Aviso al registrar movimiento de holograma en backend:", movErr);
              }
            }
          }
        }

        // 3. Si es ID persistido en BD, invocar el dictamen del backend
        if (targetId && (typeof targetId === "number" || !String(targetId).startsWith("T-ENV-"))) {
          try {
            await dispatch(dictaminarEnvasadoProducto({
              id: targetId,
              estatus: "aprobado",
              observaciones_correccion: null
            })).unwrap();
          } catch (err) {
            console.error("Error al dictaminar terminado en backend:", err);
          }
        }

        // 4. Sincronizar listas en Redux
        if (idLogin) {
          dispatch(obtenerEnvasadosTerminadosPorLogin(idLogin));
          dispatch(obtenerHologramasPorLogin(idLogin));
        }

        Swal.fire({
          icon: "success",
          title: "¡Lote Validado Exitosamente!",
          html: `El lote <strong>${record.loteEnvasado}</strong> ha sido validado exitosamente por el inspector.<br/><small style="color:#059669; font-weight:600;">Los folios de hologramas han sido descontados y registrados en el historial de Sección V.</small>`,
          confirmButtonColor: "#059669"
        });
      }
    });
  };

  // RECHAZO DEL INSPECTOR PARA PRODUCTO TERMINADO (SECCIÓN IV)
  const handleRechazarInspectorTerminado = (record) => {
    if (!record) return;

    Swal.fire({
      title: "Rechazar Lote de Envasado Terminado",
      html: `Indique las observaciones o motivos por los cuales se rechaza el lote <strong>${record.loteEnvasado}</strong>:`,
      input: "textarea",
      inputPlaceholder: "Escriba detalladamente las observaciones o correcciones requeridas...",
      inputAttributes: {
        'aria-label': 'Observaciones de corrección'
      },
      showCancelButton: true,
      confirmButtonColor: "#DC2626",
      cancelButtonColor: "#64748B",
      confirmButtonText: "Rechazar Lote",
      cancelButtonText: "Cancelar",
      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return 'Debe proporcionar las observaciones para el rechazo.';
        }
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        const obs = result.value.trim();
        const targetId = record.id_bitacora_envasado || record.id;
        const inspectorNombre = "Ing. Inspector COMERCAM (Rechazado)";
        const fecha = new Date().toISOString().split("T")[0];

        // 1. Actualizar estado local inmediatamente
        setTerminadoRecords(prev =>
          prev.map(item =>
            (item.id === record.id || (targetId && item.id_bitacora_envasado === targetId))
              ? { ...item, status: "rechazado", estatus: "rechazado", inspector: `${inspectorNombre} - ${fecha}`, observaciones_correccion: obs }
              : item
          )
        );

        // 2. Notificar al backend / base de datos
        if (targetId && (typeof targetId === "number" || !String(targetId).startsWith("T-ENV-"))) {
          try {
            await dispatch(dictaminarEnvasadoProducto({
              id: targetId,
              estatus: "rechazado",
              observaciones_correccion: obs
            })).unwrap();

            if (idLogin) {
              dispatch(obtenerEnvasadosTerminadosPorLogin(idLogin));
              dispatch(obtenerHologramasPorLogin(idLogin));
            }
          } catch (err) {
            console.error("Error al rechazar terminado en backend:", err);
          }
        }

        Swal.fire({
          icon: "warning",
          title: "Lote Rechazado",
          html: `El lote <strong>${record.loteEnvasado}</strong> ha sido marcado como <strong>Rechazado</strong> con observaciones.<br/><small style="color:#64748B;">El saldo de folios de hologramas no ha sido descontado.</small>`,
          confirmButtonColor: "#DC2626"
        });
      }
    });
  };

  // VALIDACIÓN DEL INSPECTOR PARA PRODUCTO NO TERMINADO (SECCIÓN III)
  const handleValidarInspectorNoTerminado = (record) => {
    if (!record) return;

    Swal.fire({
      title: "¿Validar Lote No Terminado?",
      html: `¿Desea otorgar el <strong>V.Bo. de la Unidad de Inspección</strong> al lote no terminado <strong>${record.loteEnvasado}</strong> (${record.marca})?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#059669",
      cancelButtonColor: "#64748B",
      confirmButtonText: "Sí, Validar V.Bo.",
      cancelButtonText: "Cancelar"
    }).then(async (result) => {
      if (result.isConfirmed) {
        const targetId = record.id_bitacora_envasado || record.id;
        const inspectorNombre = "Ing. Inspector COMERCAM (V.Bo.)";
        const fechaAprobacion = new Date().toISOString().split("T")[0];

        setNoTerminadoRecords(prev =>
          prev.map(item =>
            (item.id === record.id || (targetId && item.id_bitacora_envasado === targetId))
              ? { ...item, status: "aprobado", estatus: "aprobado", inspector: `${inspectorNombre} - ${fechaAprobacion}`, observaciones_correccion: null }
              : item
          )
        );

        if (targetId && (typeof targetId === "number" || !String(targetId).startsWith("NT-ENV-"))) {
          try {
            await dispatch(dictaminarEnvasadoProducto({
              id: targetId,
              estatus: "aprobado",
              observaciones_correccion: null
            })).unwrap();

            if (idLogin) {
              dispatch(obtenerEnvasadosNoTerminadosPorLogin(idLogin));
            }
          } catch (err) {
            console.error("Error al validar no terminado en backend:", err);
          }
        }

        Swal.fire({
          icon: "success",
          title: "¡V.Bo. Otorgado!",
          text: `El lote no terminado ${record.loteEnvasado} ha sido validado con éxito.`,
          confirmButtonColor: "#059669"
        });
      }
    });
  };

  // RECHAZO DEL INSPECTOR PARA PRODUCTO NO TERMINADO (SECCIÓN III)
  const handleRechazarInspectorNoTerminado = (record) => {
    if (!record) return;

    Swal.fire({
      title: "Rechazar Lote No Terminado",
      html: `Indique las observaciones o motivos por los cuales se rechaza el lote no terminado <strong>${record.loteEnvasado}</strong>:`,
      input: "textarea",
      inputPlaceholder: "Escriba detalladamente las observaciones o correcciones requeridas...",
      inputAttributes: {
        'aria-label': 'Observaciones de corrección'
      },
      showCancelButton: true,
      confirmButtonColor: "#DC2626",
      cancelButtonColor: "#64748B",
      confirmButtonText: "Rechazar Lote",
      cancelButtonText: "Cancelar",
      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return 'Debe proporcionar las observaciones para el rechazo.';
        }
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        const obs = result.value.trim();
        const targetId = record.id_bitacora_envasado || record.id;
        const inspectorNombre = "Ing. Inspector COMERCAM (Rechazado)";
        const fecha = new Date().toISOString().split("T")[0];

        setNoTerminadoRecords(prev =>
          prev.map(item =>
            (item.id === record.id || (targetId && item.id_bitacora_envasado === targetId))
              ? { ...item, status: "rechazado", estatus: "rechazado", inspector: `${inspectorNombre} - ${fecha}`, observaciones_correccion: obs }
              : item
          )
        );

        if (targetId && (typeof targetId === "number" || !String(targetId).startsWith("NT-ENV-"))) {
          try {
            await dispatch(dictaminarEnvasadoProducto({
              id: targetId,
              estatus: "rechazado",
              observaciones_correccion: obs
            })).unwrap();

            if (idLogin) {
              dispatch(obtenerEnvasadosNoTerminadosPorLogin(idLogin));
            }
          } catch (err) {
            console.error("Error al rechazar no terminado en backend:", err);
          }
        }

        Swal.fire({
          icon: "warning",
          title: "Lote Rechazado",
          html: `El lote <strong>${record.loteEnvasado}</strong> ha sido marcado como <strong>Rechazado</strong> con observaciones.`,
          confirmButtonColor: "#DC2626"
        });
      }
    });
  };


  const handleRegistrarEnvasadoFromGranel = (rec) => {
    const loteVal = rec.noLote || rec.no_lote || rec.noProduccion || rec.id;
    setNtNoLoteGranel(loteVal);
    if (rec.categoria) setNtCategoria(rec.categoria);
    if (rec.clase) setNtClase(rec.clase);
    const maguey = rec.tipoMaguey || rec.especie || rec.materiaPrima || rec.tipo_maguey || "";
    if (maguey) setNtTipoMaguey(maguey);
    const fq = rec.noAnalisisFisicoquimico || rec.noAnalisis || rec.clave_fq || "";
    if (fq && fq !== "-") setNtNoAnalisis(fq);
    const alc = rec.porcentaje_alc_vol || rec.invFinalAlc || rec.alcFinal || "";
    if (alc) setNtPctAlc(String(alc));
    const ing = rec.ingrediente || rec.ingredientes || (maguey ? `100% ${maguey}` : "");
    if (ing) setNtIngrediente(ing);
    if (rec.edad) setNtEdad(rec.edad);
    const vol = rec.litros || rec.invFinalVol || rec.volFinal || "";
    if (vol) setNtVolumenEnvasar(String(vol));

    setActiveTab(1);
    setIsFormOpen(true);
  };

  const handleSaveTerminado = (status) => {
    const newRecord = {
      id: `T-ENV-0${terminadoRecords.length + 1}`,
      fechaMovimiento: tFechaMovimiento,
      botCaja: tBotCaja,
      marca: tMarca,
      noLoteGranel: tNoLoteGranel,
      loteEnvasado: tLoteEnvasado,
      categoria: tCategoria,
      claseEtiqueta: tClaseEtiqueta,
      ingredientesEtiqueta: tIngredientesEtiqueta,
      edad: tEdad,
      tipoMagueyEtiqueta: tTipoMagueyEtiqueta,
      noAnalisis: tNoAnalisis,
      capacidad: tCapacidad,
      pctAlcEtiqueta: tPctAlcEtiqueta,
      noInformeAprobacion: tNoInformeAprobacion,
      fechaAprobacionEtiqueta: tFechaAprobacionEtiqueta,
      invInicialCajas: tInvInicialCajas,
      invInicialBotellas: tInvInicialBotellas,
      entradaProcedencia: tEntradaProcedencia,
      entradaCajas: tEntradaCajas,
      entradaBotellas: tEntradaBotellas,
      salidaCajas: tSalidaCajas,
      salidaBotellas: tSalidaBotellas,
      salidaDestino: tSalidaDestino,
      invFinalCajas: tInvFinalCajas,
      invFinalBotellas: tInvFinalBotellas,
      observaciones: tObservaciones || "Sin observaciones.",
      inspector: "Pendiente de V.Bo.",
      status: status
    };
    setTerminadoRecords([...terminadoRecords, newRecord]);
    setIsFormOpen(false);
    alert(status === "revision" ? "¡Movimiento de Envasado Terminado registrado exitosamente!" : "Borrador guardado.");
  };

  const handleSaveHologramas = (status) => {
    const newRecord = {
      id: `HOL-0${hologramaRecords.length + 1}`,
      idEnvasadoTerminado: hIdEnvasadoTerminado,
      fechaMovimiento: hFechaMovimiento,
      marca: hMarca,
      loteEnvasado: hLoteEnvasado,
      capacidad: hCapacidad,
      invInicialRango: hInvInicialRango,
      invInicialCant: hInvInicialCant,
      entradaRango: hEntradaRango,
      entradaCant: hEntradaCant,
      salidaRango: hSalidaRango,
      salidaCant: hSalidaCant,
      invFinalRango: hInvFinalRango,
      invFinalCant: hInvFinalCant,
      mermasRango: hMermasRango,
      mermasCant: hMermasCant,
      observaciones: hObservaciones || "Sin observaciones.",
      inspector: "Pendiente de V.Bo.",
      status: status,
      movimientos: []
    };
    setHologramaRecords([...hologramaRecords, newRecord]);
    setIsFormOpen(false);
    alert(status === "revision" ? "¡Inventario de Hologramas registrado exitosamente!" : "Borrador guardado.");
  };

  const handleRegistrarMovimientoHolograma = (idHolograma, movimientoData) => {
    setHologramaRecords(prev =>
      prev.map(item => {
        if (item.id === idHolograma) {
          const movimientosPrevios = item.movimientos || [];
          const cantConsumida = Number(movimientoData.cantidadConsumida) || 0;
          const cantMermada = Number(movimientoData.cantidadMermada) || 0;
          const totalSalidas = (Number(item.salidaCant) || 0) + cantConsumida;
          const totalMermas = (Number(item.mermasCant) || 0) + cantMermada;

          const targetIdHol = item.id_bitacora_hologramas || item.id;
          const nuevoMovimiento = {
            id: `MOV-${Date.now()}`,
            id_bitacora_hologramas: targetIdHol,
            fecha: movimientoData.fecha || new Date().toISOString().split("T")[0],
            rangoConsumido: movimientoData.rangoConsumido,
            cantidadConsumida: cantConsumida,
            rangoMermas: movimientoData.rangoMermas || "N/A",
            cantidadMermada: cantMermada,
            observaciones: movimientoData.observaciones || "Hologramas aplicados e inventario actualizado.",
            saldoRestanteRango: movimientoData.saldoRestanteRango || item.invFinalRango,
            saldoRestanteCant: movimientoData.saldoRestanteCant !== undefined ? movimientoData.saldoRestanteCant : item.invFinalCant
          };

          if (idLogin) {
            dispatch(registrarMovimientoHolograma({
              id_bitacora_hologramas: targetIdHol,
              id_bitacora_envasado: item.id_bitacora_envasado || null,
              id_login: idLogin,
              fecha: movimientoData.fecha || new Date().toISOString().split("T")[0],
              tipo_movimiento: movimientoData.tipo_movimiento || (cantMermada > 0 && cantConsumida <= 0 ? "merma" : "salida_adherido"),
              prefijo: movimientoData.prefijo || item.prefijo || "A",
              rango_inicial: movimientoData.rango_inicial || null,
              rango_final: movimientoData.rango_final || null,
              rango_completo: movimientoData.rangoConsumido || movimientoData.rangoCompleto || item.invFinalRango,
              cantidad: cantConsumida > 0 ? cantConsumida : cantMermada,
              motivo: movimientoData.motivo || "Consumo y aplicación de hologramas en botellas",
              observaciones: movimientoData.observaciones || "Movimiento registrado por asociado"
            })).then(() => {
              dispatch(obtenerHologramasPorLogin(idLogin));
            });
          }

          return {
            ...item,
            salidaRango: movimientoData.rangoConsumido,
            salidaCant: totalSalidas,
            mermasRango: movimientoData.rangoMermas || item.mermasRango,
            mermasCant: totalMermas,
            invFinalRango: movimientoData.saldoRestanteRango || item.invFinalRango,
            invFinalCant: movimientoData.saldoRestanteCant !== undefined ? movimientoData.saldoRestanteCant : item.invFinalCant,
            observaciones: movimientoData.observaciones || item.observaciones,
            movimientos: [...movimientosPrevios, nuevoMovimiento]
          };
        }
        return item;
      })
    );
  };

  // Registra una merma de hologramas (rango dentro de un inventario) en revisión para la Unidad de Inspección.
  // El saldo se descuenta hasta que la UI la acepte. Resuelve {ok, error}.
  const handleRegistrarMermaHolograma = async (merma) => {
    if (!idLogin) return { ok: false, error: "Sin sesión activa." };
    const res = await dispatch(registrarMovimientoHolograma({
      id_bitacora_hologramas: merma.id_bitacora_hologramas,
      id_login: idLogin,
      fecha: merma.fecha || new Date().toISOString().split("T")[0],
      tipo_movimiento: "merma",
      prefijo: merma.prefijo || "A",
      rango_inicial: merma.rango_inicial,
      rango_final: merma.rango_final,
      rango_completo: merma.rango_completo,
      cantidad: merma.cantidad,
      motivo: merma.motivo || "Merma de hologramas",
      observaciones: merma.observaciones || null,
      estatus: "revision"
    }));
    dispatch(obtenerHologramasPorLogin(idLogin));
    if (res?.meta?.requestStatus === "rejected") {
      return { ok: false, error: res.payload || res.error?.message || "No se pudo registrar la merma." };
    }
    return { ok: true };
  };

  const handleCompleteEnvasadoFromNoTerminado = (sourceRec, finishedData) => {
    const newTerminado = {
      id: `T-ENV-0${terminadoRecords.length + 1}`,
      idNoTerminadoOrigen: sourceRec.id,
      fechaMovimiento: sourceRec.fechaMovimiento || finishedData.fechaAprobacionEtiqueta || new Date().toISOString().split("T")[0],
      botCaja: sourceRec.botCaja || "12 botellas",
      marca: sourceRec.marca,
      noLoteGranel: sourceRec.noLoteGranel,
      loteEnvasado: sourceRec.loteEnvasado,
      categoria: sourceRec.categoria,
      claseEtiqueta: finishedData.claseEtiqueta || sourceRec.clase || "Joven / Blanco",
      ingredientesEtiqueta: finishedData.ingredientesEtiqueta || sourceRec.ingrediente || "",
      edad: sourceRec.edad || "Sin edad",
      tipoMagueyEtiqueta: finishedData.tipoMagueyEtiqueta || sourceRec.tipoMaguey || "Espadín",
      noAnalisis: sourceRec.noAnalisis,
      capacidad: sourceRec.capacidad || "750 ml",
      pctAlcEtiqueta: finishedData.pctAlcEtiqueta || sourceRec.pctAlc || "48.5",
      noInformeAprobacion: finishedData.noInformeAprobacion,
      fechaAprobacionEtiqueta: finishedData.fechaAprobacionEtiqueta,
      invInicialCajas: finishedData.invInicialCajas || "0",
      invInicialBotellas: finishedData.invInicialBotellas || "0",
      entradaProcedencia: finishedData.entradaProcedencia || `Etiquetado de lote ${sourceRec.loteEnvasado}`,
      entradaCajas: finishedData.entradaCajas || "0",
      entradaBotellas: finishedData.entradaBotellas || "0",
      salidaCajas: finishedData.salidaCajas !== undefined ? String(finishedData.salidaCajas) : "0",
      salidaBotellas: finishedData.salidaBotellas !== undefined ? String(finishedData.salidaBotellas) : "0",
      salidaDestino: finishedData.salidaDestino || "Almacén de Producto Terminado",
      invFinalCajas: finishedData.invFinalCajas !== undefined ? String(finishedData.invFinalCajas) : (finishedData.entradaCajas || "0"),
      invFinalBotellas: finishedData.invFinalBotellas !== undefined ? String(finishedData.invFinalBotellas) : (finishedData.entradaBotellas || "0"),
      observaciones: finishedData.observaciones || "Envasado Terminado (Sección IV)",
      inspector: "Pendiente de V.Bo.",
      status: "revision",
      estadoProceso: "terminado",
      rangosHologramas: finishedData.rangosHologramas || [],
      totalHologramas: finishedData.totalHologramas || 0,
      hologramasIncorporados: false
    };


    setTerminadoRecords(prev => [...prev, newTerminado]);

    setNoTerminadoRecords(prev =>
      prev.map(item =>
        item.id === sourceRec.id ? { ...item, estadoProceso: "terminado" } : item
      )
    );

    let targetId = sourceRec.id_bitacora_envasado || (typeof sourceRec.id === "number" ? sourceRec.id : null);
    if (!targetId && sourceRec.id && !isNaN(parseInt(sourceRec.id, 10)) && !String(sourceRec.id).startsWith("NT-ENV-") && !String(sourceRec.id).startsWith("HOL-") && !String(sourceRec.id).startsWith("T-ENV-")) {
      targetId = parseInt(sourceRec.id, 10);
    }
    if (!targetId) {
      const matchInDb = [...(reduxNoTerminados || []), ...(reduxTerminados || [])].find(
        r => (r.loteEnvasado && r.loteEnvasado === sourceRec.loteEnvasado) || (r.lote_envasado && r.lote_envasado === sourceRec.loteEnvasado)
      );
      if (matchInDb && (matchInDb.id_bitacora_envasado || typeof matchInDb.id === "number")) {
        targetId = parseInt(matchInDb.id_bitacora_envasado || matchInDb.id, 10);
      }
    }

    if (idLogin && targetId && !isNaN(targetId)) {
      dispatch(actualizarEnvasadoProducto({
        id: targetId,
        productoData: {
          clase_etiqueta: finishedData.claseEtiqueta || sourceRec.clase || "Joven / Blanco",
          ingredientes_etiqueta: finishedData.ingredientesEtiqueta || sourceRec.ingrediente || "",
          tipo_maguey_etiqueta: finishedData.tipoMagueyEtiqueta || sourceRec.tipoMaguey || "Espadín",
          pct_alc_etiqueta: finishedData.pctAlcEtiqueta || sourceRec.pctAlc || "48.5",
          no_informe_aprobacion: finishedData.noInformeAprobacion,
          fecha_aprobacion_etiqueta: finishedData.fechaAprobacionEtiqueta,
          inv_inicial_cajas: finishedData.invInicialCajas || 0,
          inv_inicial_botellas: finishedData.invInicialBotellas || 0,
          entrada_procedencia: finishedData.entradaProcedencia || `Etiquetado de lote ${sourceRec.loteEnvasado}`,
          entrada_cajas: finishedData.entradaCajas || 0,
          entrada_botellas: finishedData.entradaBotellas || 0,
          salida_cajas: finishedData.salidaCajas !== undefined ? Number(finishedData.salidaCajas) : 0,
          salida_botellas: finishedData.salidaBotellas !== undefined ? Number(finishedData.salidaBotellas) : 0,
          salida_destino: finishedData.salidaDestino || "Almacén de Producto Terminado",
          inv_final_cajas: finishedData.invFinalCajas !== undefined ? Number(finishedData.invFinalCajas) : 0,
          inv_final_botellas: finishedData.invFinalBotellas !== undefined ? Number(finishedData.invFinalBotellas) : 0,
          observaciones: finishedData.observaciones || "Envasado Terminado (Sección IV)",
          estado_proceso: "terminado",
          estatus: "revision",
          rangosHologramas: finishedData.rangosHologramas || [],
        }
      })).then(async (res) => {
        const loteGuardado = res?.payload?.data || res?.payload;
        await subirDocumentosPendientesDeRangos(finishedData.rangosHologramas || [], loteGuardado, idLogin);
        await subirDocumentosPendientesDeSalidas(finishedData.rangosHologramas || [], loteGuardado, idLogin);
        dispatch(obtenerEnvasadosNoTerminadosPorLogin(idLogin));
        dispatch(obtenerEnvasadosTerminadosPorLogin(idLogin));
        dispatch(obtenerHologramasPorLogin(idLogin));
      });
    }
  };

  // Agrega rangos de hologramas (salidas con su tipo de salida) a un lote terminado.
  // Devuelve una promesa que resuelve {ok, error} para que el modal muestre el resultado.
  const handleUpdateTerminado = async (updatedRecord) => {
    const lote = updatedRecord.loteEnvasado || updatedRecord.lote_envasado;

    let targetId = updatedRecord.id_bitacora_envasado || (typeof updatedRecord.id === "number" ? updatedRecord.id : null);
    if (!targetId && updatedRecord.id && !isNaN(parseInt(updatedRecord.id, 10)) && !String(updatedRecord.id).startsWith("T-ENV-")) {
      targetId = parseInt(updatedRecord.id, 10);
    }
    if (!targetId) {
      const matchInDb = (reduxTerminados || []).find(
        r => (r.loteEnvasado && r.loteEnvasado === lote) || (r.lote_envasado && r.lote_envasado === lote)
      );
      if (matchInDb && (matchInDb.id_bitacora_envasado || typeof matchInDb.id === "number")) {
        targetId = parseInt(matchInDb.id_bitacora_envasado || matchInDb.id, 10);
      }
    }

    // Sin conexión a BD (modo local): solo se actualiza el estado en memoria
    if (!(idLogin && targetId && !isNaN(targetId))) {
      setTerminadoRecords(prev => prev.map(item =>
        ((item.id && item.id === updatedRecord.id) || (lote && (item.loteEnvasado === lote || item.lote_envasado === lote)))
          ? { ...item, ...updatedRecord }
          : item
      ));
      return { ok: true };
    }

    const res = await dispatch(actualizarEnvasadoProducto({
      id: targetId,
      productoData: {
        salida_cajas: Number(updatedRecord.salidaCajas !== undefined ? updatedRecord.salidaCajas : (updatedRecord.salida_cajas || 0)),
        salida_botellas: Number(updatedRecord.salidaBotellas !== undefined ? updatedRecord.salidaBotellas : (updatedRecord.salida_botellas || 0)),
        salida_destino: updatedRecord.salidaDestino || updatedRecord.salida_destino,
        inv_final_cajas: Number(updatedRecord.invFinalCajas !== undefined ? updatedRecord.invFinalCajas : (updatedRecord.inv_final_cajas || 0)),
        inv_final_botellas: Number(updatedRecord.invFinalBotellas !== undefined ? updatedRecord.invFinalBotellas : (updatedRecord.inv_final_botellas || 0)),
        mermas: Number(updatedRecord.mermas || 0),
        observaciones: updatedRecord.observaciones,
        rangosHologramas: rangosParaEnviar(updatedRecord.rangosHologramas || [])
      }
    }));
    dispatch(obtenerEnvasadosTerminadosPorLogin(idLogin));
    dispatch(obtenerHologramasPorLogin(idLogin));
    if (res?.meta?.requestStatus === "rejected") {
      return { ok: false, error: res.payload || res.error?.message || "No se pudo guardar la salida." };
    }
    return { ok: true, data: res?.payload?.data || res?.payload };
  };

  const handleSaveHologramasFromNoTerminado = (sourceRec, hologramData) => {
    const newHologramas = {
      id: `HOL-0${hologramaRecords.length + 1}`,
      idEnvasadoTerminado: sourceRec.id,
      fechaMovimiento: sourceRec.fechaMovimiento || new Date().toISOString().split("T")[0],
      marca: sourceRec.marca,
      loteEnvasado: sourceRec.loteEnvasado,
      capacidad: sourceRec.capacidad || "750 ml",
      invInicialRango: hologramData.invInicialRango,
      invInicialCant: hologramData.invInicialCant,
      entradaRango: hologramData.entradaRango,
      entradaCant: hologramData.entradaCant,
      salidaRango: hologramData.salidaRango,
      salidaCant: hologramData.salidaCant,
      invFinalRango: hologramData.invFinalRango,
      invFinalCant: hologramData.invFinalCant,
      mermasRango: hologramData.mermasRango,
      mermasCant: hologramData.mermasCant,
      observaciones: hologramData.observaciones || "Control de Hologramas (Sección V)",
      inspector: "Pendiente de V.Bo.",
      status: "revision"
    };

    let numericTargetId = null;
    if (sourceRec.id_bitacora_envasado && !isNaN(parseInt(sourceRec.id_bitacora_envasado, 10))) {
      numericTargetId = parseInt(sourceRec.id_bitacora_envasado, 10);
    } else if (typeof sourceRec.id === "number" || (!isNaN(parseInt(sourceRec.id, 10)) && !String(sourceRec.id).startsWith("NT-ENV-") && !String(sourceRec.id).startsWith("HOL-") && !String(sourceRec.id).startsWith("T-ENV-"))) {
      numericTargetId = parseInt(sourceRec.id, 10);
    } else {
      const matchInDb = [...(reduxNoTerminados || []), ...(reduxTerminados || [])].find(
        r => (r.loteEnvasado && r.loteEnvasado === sourceRec.loteEnvasado) || (r.lote_envasado && r.lote_envasado === sourceRec.loteEnvasado)
      );
      if (matchInDb && (matchInDb.id_bitacora_envasado || typeof matchInDb.id === "number")) {
        numericTargetId = parseInt(matchInDb.id_bitacora_envasado || matchInDb.id, 10);
      }
    }

    if (idLogin && numericTargetId && !isNaN(numericTargetId)) {
      dispatch(asignarHologramasEnvasado({
        id: numericTargetId,
        rangosHologramas: rangosParaEnviar(hologramData.rangosHologramas || [])
      })).then(async (res) => {
        const loteGuardado = res?.payload?.data || res?.payload;
        await subirDocumentosPendientesDeRangos(hologramData.rangosHologramas || [], loteGuardado, idLogin);
        await subirDocumentosPendientesDeSalidas(hologramData.rangosHologramas || [], loteGuardado, idLogin);
        dispatch(obtenerEnvasadosNoTerminadosPorLogin(idLogin));
        dispatch(obtenerEnvasadosTerminadosPorLogin(idLogin));
        dispatch(obtenerHologramasPorLogin(idLogin));
      });
    }

    setNoTerminadoRecords(prev =>
      prev.map(item =>
        item.id === sourceRec.id ? { ...item, estadoProceso: "hologramado" } : item
      )
    );

    setTerminadoRecords(prev =>
      prev.map(item =>
        item.loteEnvasado === sourceRec.loteEnvasado
          ? {
            ...item,
            estadoProceso: "hologramado",
            rangosHologramas: hologramData.rangosHologramas || item.rangosHologramas,
            totalHologramas: hologramData.totalHologramas || item.totalHologramas
          }
          : item
      )
    );
  };

  const handleSaveInventarioHologramas = async (hologramData) => {
    try {
      if (idLogin) {
        await dispatch(registrarInventarioHologramas({
          ...hologramData,
          id_login: idLogin
        })).unwrap();
        await dispatch(obtenerHologramasPorLogin(idLogin));
      } else {
        const newRecord = {
          id: `HOL-0${hologramaRecords.length + 1}`,
          ...hologramData,
          invInicialRango: hologramData.rango_completo,
          invInicialCant: hologramData.cantidad_inicial,
          salidaRango: "Sin salidas",
          salidaCant: 0,
          invFinalRango: hologramData.rango_completo,
          invFinalCant: hologramData.cantidad_inicial,
          status: "activo",
          movimientos: []
        };
        setHologramaRecords(prev => [newRecord, ...prev]);
      }
      Swal.fire({
        icon: "success",
        title: "¡Inventario de Hologramas Registrado!",
        html: `Se registró exitosamente el rango <strong>${hologramData.rango_completo}</strong> (${hologramData.cantidad_inicial} piezas) al inventario oficial.`,
        confirmButtonColor: "#059669"
      });
    } catch (error) {
      console.error("Error al registrar inventario de hologramas:", error);
      Swal.fire({
        icon: "error",
        title: "Error al Registrar",
        text: typeof error === "string" ? error : (error?.message || "Ocurrió un error al guardar en la base de datos."),
        confirmButtonColor: "#DC2626"
      });
    }
  };


  const handleSaveReproceso = async (payload) => {
    try {
      const isEdit = payload.id_bitacora_reproceso || (payload.id && !String(payload.id).startsWith("REP-"));
      if (isEdit) {
        const idReproceso = payload.id_bitacora_reproceso || payload.id;
        await dispatch(actualizarReprocesoEnvasado({ id_bitacora_reproceso: idReproceso, data: payload })).unwrap();
        Swal.fire({
          icon: "success",
          title: "Actualizado",
          text: "El registro de reproceso ha sido actualizado exitosamente.",
          confirmButtonColor: "#2563eb"
        });
      } else {
        await dispatch(registrarReprocesoEnvasado({ ...payload, id_login: idLogin })).unwrap();
        Swal.fire({
          icon: "success",
          title: "Registrado",
          text: "El proceso de reproceso ha sido registrado exitosamente.",
          confirmButtonColor: "#16a34a"
        });
      }
      dispatch(obtenerReprocesosEnvasadoPorLogin(idLogin));
      recargarGranel();
    } catch (err) {
      console.error("Error guardando reproceso:", err);
      Swal.fire({
        icon: "error",
        title: "Error al guardar",
        text: typeof err === "string" ? err : (err?.message || "Ocurrió un error al procesar el reproceso."),
        confirmButtonColor: "#dc2626"
      });
    }
  };

  const handleDeleteReproceso = async (rec) => {
    const idReproceso = rec.id_bitacora_reproceso || rec.id;
    const confirm = await Swal.fire({
      title: "¿Eliminar registro?",
      text: `¿Está seguro de eliminar el registro de reproceso para el lote ${rec.loteSalida || rec.lote_salida}? Esta acción no se puede deshacer.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#6b7280",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar"
    });

    if (confirm.isConfirmed) {
      try {
        await dispatch(eliminarReprocesoEnvasado(idReproceso)).unwrap();
        Swal.fire({
          icon: "success",
          title: "Eliminado",
          text: "El registro ha sido eliminado correctamente.",
          confirmButtonColor: "#16a34a"
        });
        dispatch(obtenerReprocesosEnvasadoPorLogin(idLogin));
        recargarGranel();
      } catch (err) {
        console.error("Error eliminando reproceso:", err);
        Swal.fire({
          icon: "error",
          title: "Error al eliminar",
          text: typeof err === "string" ? err : (err?.message || "No se pudo eliminar el registro."),
          confirmButtonColor: "#dc2626"
        });
      }
    }
  };

  const handleSaveMaduracion = async (record) => {
    try {
      const isExisting = record.dbId || (record.id_bitacora_maduracion && !isNaN(Number(record.id_bitacora_maduracion))) || (typeof record.id === "number");
      const targetId = record.dbId || record.id_bitacora_maduracion || record.id;

      const payload = {
        ...record,
        id_login: idLogin
      };

      let resultAction;
      if (isExisting && targetId) {
        resultAction = await dispatch(actualizarMaduracionEnvasadoAsociado({ id: targetId, maduracionData: payload }));
      } else {
        resultAction = await dispatch(registrarMaduracionEnvasadoAsociado(payload));
      }

      if (resultAction?.error) {
        Swal.fire("Error", resultAction.payload || resultAction.error?.message || "No se pudo guardar el registro de maduración de envasado", "error");
        return;
      }

      if (idLogin) {
        dispatch(obtenerMaduracionEnvasadoPorLogin(idLogin));
        dispatch(obtenerGranelesEnvasadoPorLogin(idLogin));
        dispatch(obtenerTodosGranelesEnvasadoPorLogin(idLogin));
      }

      setIsMaduracionFormOpen(false);
      if (!record.fecha_salida_maduracion) {
        Swal.fire({
          title: "¡Éxito!",
          text: "Registro de Maduración de Envasado (Sección VII) guardado correctamente.",
          icon: "success",
          confirmButtonColor: "#D97706"
        });
      }
    } catch (err) {
      console.error("Error al guardar maduración de envasado:", err);
      Swal.fire("Error", "Ocurrió un error inesperado al guardar la maduración", "error");
    }
  };

  const handleDeleteMaduracion = async (record) => {
    const id = record.dbId || record.id_bitacora_maduracion || record.id;
    if (!id) return;

    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: `Se eliminará el registro de maduración del lote ${record.noLote || record.lote_maduracion || ""}.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#EF4444",
      cancelButtonColor: "#6B7280",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar"
    });

    if (result.isConfirmed) {
      try {
        const resAction = await dispatch(eliminarMaduracionEnvasadoAsociado(id));
        if (resAction?.error) {
          Swal.fire("Error", resAction.payload || "No se pudo eliminar el registro de maduración", "error");
        } else {
          Swal.fire("Eliminado", "Registro de maduración de envasado eliminado con éxito", "success");
          if (idLogin) {
            dispatch(obtenerMaduracionEnvasadoPorLogin(idLogin));
            dispatch(obtenerGranelesEnvasadoPorLogin(idLogin));
            dispatch(obtenerTodosGranelesEnvasadoPorLogin(idLogin));
          }
        }
      } catch (err) {
        console.error("Error al eliminar maduración de envasado:", err);
        Swal.fire("Error", "Ocurrió un error inesperado al eliminar el registro", "error");
      }
    }
  };

  const handleSaveCondiciones = async (record) => {
    try {
      const isExisting = record.dbId || (record.id_bitacora_condiciones && !isNaN(Number(record.id_bitacora_condiciones))) || (typeof record.id === "number");
      const targetId = record.dbId || record.id_bitacora_condiciones || record.id;

      const payload = {
        ...record,
        id_login: idLogin
      };

      let resultAction;
      if (isExisting && targetId) {
        resultAction = await dispatch(actualizarCondicionesEnvasadoAsociado({ id: targetId, ...payload }));
      } else {
        resultAction = await dispatch(registrarCondicionesEnvasadoAsociado(payload));
      }

      if (resultAction?.error) {
        Swal.fire("Error", resultAction.payload || resultAction.error?.message || "No se pudo guardar el registro de condiciones ambientales", "error");
        return;
      }

      if (idLogin) {
        dispatch(obtenerCondicionesEnvasadoPorLogin(idLogin));
      }

      setIsCondicionesFormOpen(false);
      Swal.fire({
        title: "¡Éxito!",
        text: "Registro de Condiciones Ambientales de Envasado guardado correctamente.",
        icon: "success",
        confirmButtonColor: "#2563EB"
      });
    } catch (err) {
      console.error("Error al guardar condiciones de envasado:", err);
      Swal.fire("Error", "Ocurrió un error inesperado al guardar las condiciones ambientales", "error");
    }
  };

  const handleDeleteCondiciones = async (id) => {
    try {
      const resultAction = await dispatch(eliminarCondicionesEnvasadoAsociado(id));
      if (resultAction?.error) {
        Swal.fire("Error", resultAction.payload || resultAction.error?.message || "No se pudo eliminar el registro", "error");
      } else {
        Swal.fire("¡Eliminado!", "Registro de condiciones ambientales eliminado correctamente.", "success");
        if (idLogin) {
          dispatch(obtenerCondicionesEnvasadoPorLogin(idLogin));
        }
      }
    } catch (err) {
      console.error("Error al eliminar condiciones de envasado:", err);
      Swal.fire("Error", "Ocurrió un error inesperado al eliminar el registro", "error");
    }
  };

  const handleReloadReproceso = useCallback(() => {
    if (idLogin) {
      dispatch(obtenerReprocesosEnvasadoPorLogin(idLogin));
      dispatch(obtenerGranelesEnvasadoPorLogin(idLogin));
    }
  }, [dispatch, idLogin]);

  const handleReloadMaduracion = useCallback(() => {
    if (idLogin) {
      dispatch(obtenerMaduracionEnvasadoPorLogin(idLogin));
      dispatch(obtenerGranelesEnvasadoPorLogin(idLogin));
    }
  }, [dispatch, idLogin]);

  const handleReloadCondiciones = useCallback(() => {
    if (idLogin) {
      dispatch(obtenerCondicionesEnvasadoPorLogin(idLogin));
    }
  }, [dispatch, idLogin]);

  const handleSaveQueja = (status) => {
    const newRecord = {
      id: quejasRecords.length + 1,
      fechaQueja,
      noQueja,
      noLote: quejaNoLote,
      descripcionProducto,
      detalleQueja,
      fechaAtencion,
      medidasCorrectivas,
      inspector: "Pendiente de V.Bo.",
      status: status
    };
    setQuejasRecords([...quejasRecords, newRecord]);
    setIsFormOpen(false);
    setNoQueja("");
    setDetalleQueja("");
    setMedidasCorrectivas("");
    alert(status === "revision" ? "¡Queja registrada exitosamente!" : "Borrador guardado.");
  };

  return (
    <div className="container2">
      {/* Decorative Blurs */}
      <div className="glow-blob glow-1"></div>
      <div className="glow-blob glow-2"></div>

      {/* HEADER */}
      <header className="main-trace-header">
        <div className="header-branding">
          <div className="header-icon-box" style={{ background: "linear-gradient(135deg, #10B981 0%, #059669 100%)", boxShadow: "0 8px 18px rgba(16, 185, 129, 0.25)" }}>
            <LocalBarIcon style={{ fontSize: 30 }} />
          </div>
          <div>
            <div className="header-tag">COMERCAM • TRAZABILIDAD COMERCIAL</div>
            <h1>Bitácora de Envasado de Mezcal</h1>
            <p>Control integral de inventarios a granel, producto no terminado, terminado y control de hologramas</p>
          </div>
        </div>

        <div className="header-controls-envasado">
          <span className={`status-badge-envasado ${tabsInfo[activeTab]?.theme || 'status-cierre'}`}>
            {tabsInfo[activeTab]?.title} • {tabsInfo[activeTab]?.name}
          </span>
        </div>
      </header>

      {/* SECTIONS TABS (SEGMENTED PILLS) */}
      <div className="tabs-nav-bar-container">
        <div className="segmented-pill-container">
          {tabsInfo.map((tab) => {
            const IconComponent = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                className={`segmented-pill-btn ${isActive ? "active" : ""}`}
                onClick={() => {
                  setActiveTab(tab.id);
                  setIsFormOpen(false);
                }}
              >
                <IconComponent style={{ fontSize: 16 }} />
                <span>{tab.shortLabel}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* ACTIVE SECTION CONTENT */}
      <main className="section-tab-container animate-fadeIn">

        {/* SECCIÓN II: GRANEL */}
        {activeTab === 0 && (
          <InventarioGranelSection
            granelRecords={effectiveGranelRecords}
            allGranelRecords={reduxAllGranelRecords}
            pagination={reduxGranelPagination}
            currentPage={granelPage}
            setCurrentPage={setGranelPage}
            limit={granelLimit}
            setLimit={setGranelLimit}
            onPageChange={(newPage) => {
              setGranelPage(newPage);
              recargarGranel(newPage, granelLimit);
            }}
            onLimitChange={(newLimit) => {
              setGranelLimit(newLimit);
              setGranelPage(1);
              recargarGranel(1, newLimit);
            }}
            catalogoMaguey={reduxCatalogoMaguey}
            availableInstalaciones={availableInstalaciones}
            produccionLots={reduxGranelesProduccion}
            isFormOpen={isFormOpen}
            setIsFormOpen={setIsFormOpen}
            formData={granelFormData}
            setFormData={setGranelFormData}
            handleSaveGranel={handleSaveGranel}
            handleCancelGranel={handleCancelGranel}
            handleEditRecord={handleEditGranelRecord}
            handleOpenNewRecord={handleOpenNewGranelRecord}
            handleSaveFusion={handleSaveFusion}
            handleUndoGranel={handleUndoGranel}
            handleSaveTraslado={handleSaveTraslado}
            handleSaveDilucion={handleSaveDilucion}
            handleSaveBaja={handleSaveBaja}
            handleSaveMuestreo={handleSaveMuestreo}
            onRegistrarEnvasado={handleRegistrarEnvasadoFromGranel}
            handleRefreshGranel={handleRefreshGranel}
            isRefreshingGranel={isRefreshingGranel}
            terminadoRecords={terminadoRecords}
          />
        )}

        {/* SECCIÓN III: ENVASADO NO TERMINADO */}
        {activeTab === 1 && (
          <EnvasadoNoTerminadoSection
            idLogin={idLogin}
            noTerminadoRecords={effectiveNoTerminadoRecords}
            granelRecords={effectiveGranelRecords}
            isFormOpen={isFormOpen}
            setIsFormOpen={setIsFormOpen}
            fechaMovimiento={ntFechaMovimiento}
            setFechaMovimiento={setNtFechaMovimiento}
            botCaja={ntBotCaja}
            setBotCaja={setNtBotCaja}
            marca={ntMarca}
            setMarca={setNtMarca}
            noLoteGranel={ntNoLoteGranel}
            setNoLoteGranel={setNtNoLoteGranel}
            volumenEnvasar={ntVolumenEnvasar}
            setVolumenEnvasar={setNtVolumenEnvasar}
            noInformeAprobacion={ntNoInformeAprobacion}
            setNoInformeAprobacion={setNtNoInformeAprobacion}
            loteEnvasado={ntLoteEnvasado}
            setLoteEnvasado={setNtLoteEnvasado}
            categoria={ntCategoria}
            setCategoria={setNtCategoria}
            clase={ntClase}
            setClase={setNtClase}
            ingrediente={ntIngrediente}
            setIngrediente={setNtIngrediente}
            edad={ntEdad}
            setEdad={setNtEdad}
            tipoMaguey={ntTipoMaguey}
            setTipoMaguey={setNtTipoMaguey}
            noAnalisis={ntNoAnalisis}
            setNoAnalisis={setNtNoAnalisis}
            capacidad={ntCapacidad}
            setCapacidad={setNtCapacidad}
            pctAlc={ntPctAlc}
            setPctAlc={setNtPctAlc}
            invInicialCajas={ntInvInicialCajas}
            setInvInicialCajas={setNtInvInicialCajas}
            invInicialBotellas={ntInvInicialBotellas}
            setInvInicialBotellas={setNtInvInicialBotellas}
            entradaProcedencia={ntEntradaProcedencia}
            setEntradaProcedencia={setNtEntradaProcedencia}
            entradaCajas={ntEntradaCajas}
            setEntradaCajas={setNtEntradaCajas}
            entradaBotellas={ntEntradaBotellas}
            setEntradaBotellas={setNtEntradaBotellas}
            salidaCajas={ntSalidaCajas}
            setSalidaCajas={setNtSalidaCajas}
            salidaBotellas={ntSalidaBotellas}
            setSalidaBotellas={setNtSalidaBotellas}
            salidaDestino={ntSalidaDestino}
            setSalidaDestino={setNtSalidaDestino}
            invFinalCajas={ntInvFinalCajas}
            setInvFinalCajas={setNtInvFinalCajas}
            invFinalBotellas={ntInvFinalBotellas}
            setInvFinalBotellas={setNtInvFinalBotellas}
            mermas={ntMermas}
            setMermas={setNtMermas}
            observaciones={ntObservaciones}
            setObservaciones={setNtObservaciones}
            handleSaveNoTerminado={handleSaveNoTerminado}
            onCompleteEnvasado={handleCompleteEnvasadoFromNoTerminado}
            onSaveHologramas={handleSaveHologramasFromNoTerminado}
            hologramaRecords={effectiveHologramaRecords}
            terminadoRecords={effectiveTerminadoRecords}
          />
        )}

        {/* SECCIÓN IV: ENVASADO TERMINADO */}
        {activeTab === 2 && (
          <EnvasadoTerminadoSection
            terminadoRecords={effectiveTerminadoRecords}
            hologramaRecords={effectiveHologramaRecords}
            onUpdateTerminado={handleUpdateTerminado}
            almacenes={almacenInstalaciones}
          />
        )}

        {/* SECCIÓN V: CONTROL DE HOLOGRAMAS */}
        {activeTab === 3 && (
          <ControlHologramasSection
            hologramaRecords={effectiveHologramaRecords}
            terminadoRecords={effectiveTerminadoRecords}
            isFormOpen={isFormOpen}
            setIsFormOpen={setIsFormOpen}
            idEnvasadoTerminado={hIdEnvasadoTerminado}
            setIdEnvasadoTerminado={setHIdEnvasadoTerminado}
            fechaMovimiento={hFechaMovimiento}
            setFechaMovimiento={setHFechaMovimiento}
            marca={hMarca}
            setMarca={setHMarca}
            loteEnvasado={hLoteEnvasado}
            setLoteEnvasado={setHLoteEnvasado}
            capacidad={hCapacidad}
            setCapacidad={setHCapacidad}
            invInicialRango={hInvInicialRango}
            setInvInicialRango={setHInvInicialRango}
            invInicialCant={hInvInicialCant}
            setInvInicialCant={setHInvInicialCant}
            entradaRango={hEntradaRango}
            setEntradaRango={setHEntradaRango}
            entradaCant={hEntradaCant}
            setEntradaCant={setHEntradaCant}
            salidaRango={hSalidaRango}
            setSalidaRango={setHSalidaRango}
            salidaCant={hSalidaCant}
            setSalidaCant={setHSalidaCant}
            invFinalRango={hInvFinalRango}
            setInvFinalRango={setHInvFinalRango}
            invFinalCant={hInvFinalCant}
            setInvFinalCant={setHInvFinalCant}
            mermasRango={hMermasRango}
            setMermasRango={setHMermasRango}
            mermasCant={hMermasCant}
            setMermasCant={setHMermasCant}
            observaciones={hObservaciones}
            setObservaciones={setHObservaciones}
            handleSaveHologramas={handleSaveHologramas}
            onSaveInventarioHologramas={handleSaveInventarioHologramas}
            onReloadHologramas={() => {
              if (!idLogin) return;
              dispatch(obtenerHologramasPorLogin(idLogin));
              dispatch(obtenerEnvasadosTerminadosPorLogin(idLogin));
            }}
            onRegistrarMovimiento={handleRegistrarMovimientoHolograma}
            onRegistrarMerma={handleRegistrarMermaHolograma}
          />
        )}

        {/* SECCIÓN VI: REPROCESO (ELABORACIÓN DE CLASES) */}
        {activeTab === 4 && (
          <ReprocesoSection
            reprocesoRecords={reduxReprocesos}
            granelRecords={effectiveGranelRecords}
            allGranelRecords={reduxAllGranelRecords}
            isFormOpen={isReprocesoFormOpen}
            setIsFormOpen={setIsReprocesoFormOpen}
            formData={reprocesoFormData}
            setFormData={setReprocesoFormData}
            handleSaveReproceso={handleSaveReproceso}
            handleDeleteReproceso={handleDeleteReproceso}
            onReloadReproceso={handleReloadReproceso}
          />
        )}

        {/* SECCIÓN VII: MADURACIÓN DE ENVASADO */}
        {activeTab === 5 && (
          <InventarioMaduracionSection
            maduracionRecords={maduracionRecords}
            granelRecords={effectiveGranelRecords}
            isFormOpen={isMaduracionFormOpen}
            setIsFormOpen={setIsMaduracionFormOpen}
            formData={maduracionFormData}
            setFormData={setMaduracionFormData}
            handleSaveMaduracion={handleSaveMaduracion}
            handleDeleteMaduracion={handleDeleteMaduracion}
            onReloadMaduracion={handleReloadMaduracion}
          />
        )}

        {/* SECCIÓN VIII: CONDICIONES */}
        {activeTab === 6 && (
          <CondicionesSection
            condicionesRecords={reduxCondicionesRecords}
            isFormOpen={isCondicionesFormOpen}
            setIsFormOpen={setIsCondicionesFormOpen}
            formData={condicionesFormData}
            setFormData={setCondicionesFormData}
            handleSaveCondiciones={handleSaveCondiciones}
            handleDeleteCondiciones={handleDeleteCondiciones}
            onReloadCondiciones={handleReloadCondiciones}
          />
        )}

        {/* SECCIÓN IX: QUEJAS */}
        {activeTab === 7 && (
          <QuejasSection
            quejasRecords={quejasRecords}
            terminadoRecords={terminadoRecords}
            isFormOpen={isFormOpen}
            setIsFormOpen={setIsFormOpen}
            fechaQueja={fechaQueja}
            setFechaQueja={setFechaQueja}
            noQueja={noQueja}
            setNoQueja={setNoQueja}
            noLote={quejaNoLote}
            setNoLote={setQuejaNoLote}
            descripcionProducto={descripcionProducto}
            setDescripcionProducto={setDescripcionProducto}
            detalleQueja={detalleQueja}
            setDetalleQueja={setDetalleQueja}
            fechaAtencion={fechaAtencion}
            setFechaAtencion={setFechaAtencion}
            medidasCorrectivas={medidasCorrectivas}
            setMedidasCorrectivas={setMedidasCorrectivas}
            handleSaveQueja={handleSaveQueja}
          />
        )}

      </main>
    </div>
  );
};

export default BitacoraEnvasado;